import React, { useEffect, useMemo, useState, useRef } from "react";
import {
  FormControl,
  Select,
  MenuItem,
  Collapse,
  TextField,
  Autocomplete,
  Checkbox,
  Avatar,
  Switch,
  FormControlLabel,
  Radio,
  RadioGroup,
  Tooltip,
} from "@mui/material";
import TableDownloader from "../TableDownloader";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Box,
  Typography,
  IconButton,
  Paper,
  DialogContent,
  DialogActions,
  DialogTitle,
  Dialog,
} from "@mui/material";
import DateRangeIcon from "@mui/icons-material/DateRange";
import { Offcanvas } from "react-bootstrap";
import { IoIosArrowBack } from "react-icons/io";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { width } from "@mui/system";
import { OffcanvasBody } from "react-bootstrap";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import {
  fetchAllEntities,
  fetchEntityById,
  getAllData,
  getAllNameList,
  postResource,
} from "../../apis/apiService";
import { toast } from "react-toastify";
// import * as React from 'react';
import clsx from "clsx";
import { styled, css } from "@mui/system";
import { Modal as BaseModal } from "@mui/material";
// import WeekPicker from "./WeeckPicker";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import {
  LocalizationProvider,
  MonthCalendar,
  StaticDatePicker,
  DatePicker,
} from "@mui/x-date-pickers";
import MonthPicker from "./MonthPicker";
import dayjs from "dayjs";
import { WeekPicker } from "./WeeckPicker";
import { Controller, useForm } from "react-hook-form";
import { RangePicker } from "./RangePicker";
import { useSelector } from "react-redux";
import {
  useFetchBudgetExpenseTableQuery,
  useFetchBudgetPaymentsQuery,
  useFetchBudgetSummaryTableQuery,
  useFetchBudgetAdditionalScopesQuery,
  useAddAdditionalScopeMutation,
  useUpdateAdditionalScopeMutation,
  useDeleteAdditionalScopeMutation,
  useFetchViewProjectsByIdQuery,
  useFetchBudgetOverviewQuery,
  useUpdateBudgetPaymentMutation,
  useDeleteBudgetPaymentMutation,
  useDeleteManualInvoiceMutation,
} from "../../slice/logdetailSlice";
import Loader from "../common/Loader";
import { DateRangePicker } from "react-date-range";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useTheme } from "../../ThemeContext";
import Swal from "sweetalert2";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import { CiExport } from "react-icons/ci";
import { saveAs } from "file-saver";
import ttLogo from "../../assets/images/Auth/logo_TT_new.png";
import BudgetStatusCard from "./BudgetStatusCard";
import { useBudgetTracking } from "../../hooks/useBudgetTracking";
import { formatINR, validatePositiveAmount } from "../../utils/amount";
import CustomDateRangePicker from "./CustomDateRangePicker";
// import { Button } from '@mui/base/Button';

export function NestedModal({ onApply, onCancel }) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleApply = (date) => {
    onApply(date);
    handleClose(); // Close the modal
  };

  return (
    <div>
      <div className="w-100 border-0 ">
        <DateRangeIcon onClick={handleOpen} />
      </div>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
        slots={{ backdrop: StyledBackdrop }}
      >
        <ModalContent sx={style}>
          {/* <Weekpic /> */}
          <WeekPicker onApply={handleApply} onCancel={onCancel} />
          {/* <RangePicker /> */}
          {/* <MonthPicker /> */}
        </ModalContent>
      </Modal>
    </div>
  );
}


export function NestedRange({ onApply, onCancel }) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleApply = (dates) => {
    onApply(dates); // Pass the selected dates to the parent handler
    handleClose(); // Close the modal
  };

  return (
    <div>
      <DateRangeIcon onClick={handleOpen} />
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
        slots={{ backdrop: StyledBackdrop }}
      >
        <ModalContent sx={style}>
          {/* <Weekpic /> */}
          {/* <WeekPicker  /> */}
          <RangePicker onApply={handleApply} onCancel={onCancel} />
          {/* <MonthPicker /> */}
        </ModalContent>
      </Modal>
    </div>
  );
}

export function NesteMonthdModal({ onApply, onCancel }) {
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleApply = (dates) => {
    onApply(dates); // Pass the selected dates to the parent handler
    handleClose(); // Close the modal
  };

  const handleCancel = () => {
    onCancel();
    handleClose(); // Close the modal
  };

  return (
    <div>
      {/* <Typography className="w-100 border-0 px-3 py-2 " onClick={handleOpen}>
        This Month
      </Typography> */}
      <DateRangeIcon onClick={handleOpen} />
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
        slots={{ backdrop: StyledBackdrop }}
      >
        <ModalContent sx={style}>
          <MonthPicker onApply={handleApply} onCancel={handleCancel} />
        </ModalContent>
      </Modal>
    </div>
  );
}

const Backdrop = React.forwardRef((props, ref) => {
  const { open, className, ...other } = props;
  return (
    <div
      className={`${open ? "base-Backdrop-open" : ""} ${className}`}
      ref={ref}
      {...other}
    />
  );
});

const blue = {
  200: "#99CCFF",
  300: "#66B2FF",
  400: "#3399FF",
  500: "#007FFF",
  600: "#0072E5",
  700: "#0066CC",
};

const grey = {
  50: "#F3F6F9",
  100: "#E5EAF2",
  200: "#DAE2ED",
  300: "#C7D0DD",
  400: "#B0B8C4",
  500: "#9DA8B7",
  600: "#6B7A90",
  700: "#434D5B",
  800: "#303740",
  900: "#1C2025",
};

const Modal = styled(BaseModal)`
  position: fixed;
  z-index: 1300;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const StyledBackdrop = styled(Backdrop)`
  z-index: -1;
  position: fixed;
  inset: 0;
  background-color: rgb(0 0 0 / 0.5);
  -webkit-tap-highlight-color: transparent;
`;

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
};

const ModalContent = styled("div")(
  ({ theme }) => css`
    font-family: "IBM Plex Sans", sans-serif;
    font-weight: 500;
    text-align: start;
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 8px;
    overflow: hidden;
    background-color: ${theme.palette.mode === "dark" ? grey[900] : "#fff"};
    border-radius: 8px;
    border: 1px solid ${theme.palette.mode === "dark" ? grey[700] : grey[200]};
    box-shadow: 0 4px 12px
      ${theme.palette.mode === "dark" ? "rgb(0 0 0 / 0.5)" : "rgb(0 0 0 / 0.2)"};
    padding: 24px;
    color: ${theme.palette.mode === "dark" ? grey[50] : grey[900]};

    & .modal-title {
      margin: 0;
      line-height: 1.5rem;
      margin-bottom: 8px;
    }

    & .modal-description {
      margin: 0;
      line-height: 1.5rem;
      font-weight: 400;
      color: ${theme.palette.mode === "dark" ? grey[400] : grey[800]};
      margin-bottom: 4px;
    }
  `
);

const allSelect = [
  {
    label: "user 1",
    value: 1,
  },
  {
    label: "Budget 1",
    value: 2,
  },
];

const projectSpan = [
  {
    label: "Project span",
    value: 0,
  },
  {
    label: "Project 2",
    value: 1,
  },
];

// const data = [
//   {
//     id: "01",
//     name: "Raj",
//     rows: [
//       {
//         hours: 3.42,
//         rate: 301,
//         dateRange: "25-Feb-2021 to 31-Aug-2021",
//         totalHrs: 7.08,
//         totalAmount: 2405.67,
//       },
//       {
//         hours: 3.42,
//         rate: 301,
//         dateRange: "25-Feb-2021 to 31-Aug-2021",
//         totalHrs: 7.08,
//         totalAmount: 2405.67,
//       },
//       {
//         hours: 3.42,
//         rate: 301,
//         dateRange: "25-Feb-2021 to 31-Aug-2021",
//         totalHrs: 7.08,
//         totalAmount: 2405.67,
//       },
//       {
//         hours: 3.42,
//         rate: 301,
//         dateRange: "25-Feb-2021 to 31-Aug-2021",
//         totalHrs: 7.08,
//         totalAmount: 2405.67,
//       },
//     ],
//   },
//   {
//     id: "02",
//     name: "Suresh",
//     rows: [
//       {
//         hours: 3.42,
//         rate: 301,
//         dateRange: "25-Feb-2021 to 31-Aug-2021",
//         totalHrs: 7.08,
//         totalAmount: 2405.67,
//       },
//       {
//         hours: 3.42,
//         rate: 301,
//         dateRange: "25-Feb-2021 to 31-Aug-2021",
//         totalHrs: 7.08,
//         totalAmount: 2405.67,
//       },
//       {
//         hours: 3.42,
//         rate: 301,
//         dateRange: "25-Feb-2021 to 31-Aug-2021",
//         totalHrs: 7.08,
//         totalAmount: 2405.67,
//       },
//       {
//         hours: 3.42,
//         rate: 301,
//         dateRange: "25-Feb-2021 to 31-Aug-2021",
//         totalHrs: 7.08,
//         totalAmount: 2405.67,
//       },
//     ],
//   },
//   {
//     id: "03",
//     name: "Krishnan",
//     rows: [
//       {
//         hours: 3.42,
//         rate: 301,
//         dateRange: "25-Feb-2021 to 31-Aug-2021",
//         totalHrs: 7.08,
//         totalAmount: 2405.67,
//       },
//       {
//         hours: 3.42,
//         rate: 301,
//         dateRange: "25-Feb-2021 to 31-Aug-2021",
//         totalHrs: 7.08,
//         totalAmount: 2405.67,
//       },
//       {
//         hours: 3.42,
//         rate: 301,
//         dateRange: "25-Feb-2021 to 31-Aug-2021",
//         totalHrs: 7.08,
//         totalAmount: 2405.67,
//       },
//       {
//         hours: 3.42,
//         rate: 301,
//         dateRange: "25-Feb-2021 to 31-Aug-2021",
//         totalHrs: 7.08,
//         totalAmount: 2405.67,
//       },
//     ],
//   },
// ];
// const columns = [
//   { headerName: "S.No", field: "id" },
//   { headerName: "Name", field: "name" },
//   { headerName: "Hours", field: "hours" },
//   { headerName: "Rate / hr", field: "rate" },
//   { headerName: "Date Range", field: "dateRange" },
//   { headerName: "Total Hrs", field: "totalHrs" },
//   { headerName: "Total Amount", field: "totalAmount" },
// ];

// const rows = data.flatMap((group) =>
//   group.rows.map((row) => ({
//     id: group.id,
//     name: group.name,
//     ...row,
//   }))
// );
// // const calculateTotalAmount = () => {
// //   return data.reduce((sum, group) => {
// //     return (
// //       sum + group.rows.reduce((subSum, row) => subSum + row.totalAmount, 0)
// //     );
// //   }, 0);
// // };

export const AddPaymentComponent = ({ onapply, oncancel, onRefetch }) => {
  const project_id = localStorage.getItem("project_id");
  const [loading, isLoading] = useState(false);
  const { data, refetch } = useFetchBudgetPaymentsQuery(project_id);
  const {
    data: summaryData,
    refetch: summaryRefetch,
    currentData,
    isLoading: summary_isloading,
  } = useFetchBudgetSummaryTableQuery(project_id);
  const {
    handleSubmit,
    reset,
    register,
    formState: { errors },
  } = useForm({
    defaultValues: {
      amount: "",
      remarks: "",
    },
  });

  const onSubmit = async (data) => {
    isLoading(true);
    const amount = parseInt(data.amount, 10);
    //console.log("addd expense data :", data);
    const requestedData = {
      remarks: data.remarks,
      amount: amount,
    };
    try {
      const response = await postResource(
        "projects/budget",
        "addPayment",
        project_id,
        requestedData
      );
      if (response) {
        toast.success("Payment added successfully");
        // onapply();
        // reset();
        refetch();
        summaryRefetch();
        if (onRefetch) onRefetch();
        oncancel();
      }
      //console.log("add expenses :", response);
    } 
    catch (err) {
      const errorMsg = err.message;
      toast.error(errorMsg);
    } 
    finally {
      isLoading(false);
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div
          className="d-flex gap-1 align-items-center mt-1"
          onClick={oncancel}
          style={{ cursor: "pointer" }}
        >
          <div>
            <IoIosArrowBack />
          </div>
          <Typography
            sx={{ fontWeight: 500, fontSize: "15px", textTransform: "capitalize" }}
          >
            Add Payment
          </Typography>
        </div>

        <div className="p-4 paddingBtn">
          <div className="mt-3 mb-3">
            <label htmlFor="payment_remarks" className="form-label d-block w-100 mb-2" style={{ color: "#777", fontSize: "14px", fontWeight: 500 }}>
              Remarks <span className="errorMsg">*</span>
            </label>

            <TextField
              sx={{ width: "100%" }}
              size="small"
              name="remarks"
              placeholder="Enter remarks"
              {...register("remarks", {
                required: "Remarks field is required",
              })}
            />
            {errors.remarks && (
              <p className="errorMsg">{errors.remarks.message}</p>
            )}
          </div>

          <div className="mt-3 mb-3">
            <label htmlFor="payment_amount" className="form-label d-block w-100 mb-2" style={{ color: "#777", fontSize: "14px", fontWeight: 500 }}>
              Amount <span className="errorMsg">*</span>
            </label>

            <TextField
              sx={{ width: "100%" }}
              size="small"
              name="amount"
              type="text"
              inputProps={{ inputMode: "numeric" }}
              placeholder="Enter amount"
              onKeyDown={(e) => {
                if (
                  !/[0-9]/.test(e.key) &&
                  !["Backspace", "Tab", "ArrowLeft", "ArrowRight", "Delete", "Enter"].includes(e.key)
                ) {
                  e.preventDefault();
                }
              }}
              {...register("amount", {
                required: "Amount field is required",
                validate: validatePositiveAmount,
                pattern: {
                  value: /^[0-9]+$/,
                  message: "Only numbers are allowed",
                },
                onChange: (e) => {
                  e.target.value = e.target.value.replace(/[^0-9]/g, "");
                },
              })}
            />
            {errors.amount && (
              <p className="errorMsg">{errors.amount.message}</p>
            )}
          </div>
        </div>

        <div className="d-flex p-3 align-items-center position-absolute bottom-0 w-100 bg-white gap-3">
          <button
            type="submit"
            className="add_btn"
            disabled={loading}
            onClick={onapply}
          >
            {loading ? "Adding..." : "Add"}
          </button>
          <button className="cancel_btn" type="button" onClick={oncancel}>
            Cancel
          </button>
        </div>
      </form>
    </>
  );
};

export const renderPaymentRemarks = (comments) => {
  if (!comments) return "-";
  const str = String(comments).trim();

  // Pattern: "Invoice #<inv_number> - <desc>" or "Invoice #<inv_number>" or "Invoice <inv_number> - <desc>"
  const match = str.match(/^(Invoice\s*)#?([A-Za-z0-9_-]+)(.*)$/i);
  if (match) {
    const [, prefix, invNumber, rest] = match;
    return (
      <span>
        <span style={{ fontWeight: 600 }}>
          {prefix.trim()} {invNumber}
        </span>
        {rest}
      </span>
    );
  }

  return str;
};

const EditPaymentComponent = ({ oncancel, initialData, onRefetch }) => {
  const [updateBudgetPayment] = useUpdateBudgetPaymentMutation();
  const [loading, setLoading] = useState(false);
  const project_id = localStorage.getItem("project_id");

  const {
    handleSubmit,
    register,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      amount: "",
      remarks: "",
    },
  });

  useEffect(() => {
    if (initialData) {
      // The list API sends amounts as "10,000.00", but this form (and the
      // update endpoint) only take whole numbers.
      const parsedAmt = Math.round(
        parseFloat(String(initialData.amount ?? "").replace(/,/g, ""))
      );
      const rawRemarks = initialData.comments || "";
      const cleanedRemarks = rawRemarks.replace(/^(Invoice\s*)#([A-Za-z0-9_-]+)/i, "$1$2");
      reset({
        remarks: cleanedRemarks,
        amount: Number.isFinite(parsedAmt) ? String(parsedAmt) : "",
      });
    }
  }, [initialData, reset]);

  const onSubmit = async (data) => {
    setLoading(true);
    const amount = parseInt(data.amount, 10);
    const requestedData = {
      remarks: data.remarks,
      amount: amount,
    };
    try {
      const response = await updateBudgetPayment({
        project_id,
        payment_id: initialData.payments_received_id,
        data: requestedData,
      }).unwrap();
      
      if (response && response.status) {
        toast.success(response.message || "Payment updated successfully");
        if (onRefetch) onRefetch();
        oncancel();
      }
    } catch (err) {
      toast.error(err?.data?.message || "Error updating payment");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div
          className="d-flex gap-1 align-items-center mt-1"
          onClick={oncancel}
          style={{ cursor: "pointer" }}
        >
          <div>
            <IoIosArrowBack />
          </div>
          <Typography
            sx={{ fontWeight: 500, fontSize: "15px", textTransform: "capitalize" }}
          >
            Edit Payment
          </Typography>
        </div>

        <div className="p-4 paddingBtn">
          <div className="mt-3 mb-3">
            <label className="form-label d-block w-100 mb-2" style={{ color: "#777", fontSize: "14px", fontWeight: 500 }}>
              Remarks <span className="errorMsg">*</span>
            </label>
            <TextField
              sx={{ width: "100%" }}
              size="small"
              name="remarks"
              placeholder="Enter remarks"
              {...register("remarks", {
                required: "Remarks field is required",
              })}
            />
            {errors.remarks && (
              <p className="errorMsg">{errors.remarks.message}</p>
            )}
          </div>

          <div className="mt-3 mb-3">
            <label className="form-label d-block w-100 mb-2" style={{ color: "#777", fontSize: "14px", fontWeight: 500 }}>
              Amount <span className="errorMsg">*</span>
            </label>
            <TextField
              sx={{ width: "100%" }}
              size="small"
              name="amount"
              type="text"
              inputProps={{ inputMode: "numeric" }}
              placeholder="Enter amount"
              onKeyDown={(e) => {
                if (!/[0-9]/.test(e.key) && !["Backspace", "Tab", "ArrowLeft", "ArrowRight", "Delete", "Enter"].includes(e.key)) {
                  e.preventDefault();
                }
              }}
              {...register("amount", {
                required: "Amount field is required",
                validate: validatePositiveAmount,
                pattern: { value: /^[0-9]+$/, message: "Only numbers are allowed" },
                onChange: (e) => { e.target.value = e.target.value.replace(/[^0-9]/g, ""); },
              })}
            />
            {errors.amount && (
              <p className="errorMsg">{errors.amount.message}</p>
            )}
          </div>
        </div>

        <div className="d-flex p-3 align-items-center position-absolute bottom-0 w-100 bg-white gap-3">
          <button type="submit" className="add_btn" disabled={loading}>
            {loading ? "Updating..." : "Update"}
          </button>
          <button className="cancel_btn" type="button" onClick={oncancel}>
            Cancel
          </button>
        </div>
      </form>
    </>
  );
};

export const AddExpenseComponent = ({ oncancel, onapply, onclose, onRefetch }) => {                                     
  const {
    handleSubmit,
    register,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      amount: "",
      remarks: "",
    },
  });
  const [loading, setLoading] = useState(false);
  const project_id = localStorage.getItem("project_id"); // pass value as 4 backend
  const { data, isLoading, refetch } = useFetchBudgetExpenseTableQuery(project_id);

  const onSubmit = async (data) => {
    setLoading(true);
    const amount = parseInt(data.amount, 10);
    const requestedData = {
      remarks: data.remarks,
      amount: amount,
    };
    try {
      const response = await postResource(
        "projects/budget",
        "addExpense",
        project_id,
        requestedData
      );
      if (response) {
        toast.success(response.message);
        refetch();
        if (onRefetch) onRefetch();
        oncancel();
      }
    } 
    catch (err) {
      //console.log("error in add expense budget : ", err);

      const errorMsg = err.message;
      toast.error(errorMsg);
    } 
    finally {
      setLoading(false);
    }
  };
  
  return (
    <>
      <form action="" onSubmit={handleSubmit(onSubmit)}>
        <div
          className="d-flex gap-1 align-items-center mt-1"
          onClick={oncancel}
          style={{ cursor: "pointer" }}
        >
          <div>
            <IoIosArrowBack />
          </div>
          <Typography
            sx={{ fontWeight: 500, fontSize: "15px", textTransform: "capitalize" }}
          >
            Add Expense
          </Typography>
        </div>

        <div className="p-4 paddingBtn">
          <div className="mt-3 mb-3">
            <label htmlFor="expense_remarks" className="form-label d-block w-100 mb-2" style={{ color: "#777", fontSize: "14px", fontWeight: 500 }}>
              Remarks <span className="errorMsg">*</span>
            </label>

            <TextField
              sx={{ width: "100%" }}
              size="small"
              name="remarks"
              placeholder="Enter remarks"
              {...register("remarks", {
                required: "Remarks field is required",
              })}
            />
            {errors.remarks && (
              <p className="errorMsg">{errors.remarks.message}</p>
            )}
          </div>

          <div className="mt-3 mb-3">
            <label htmlFor="expense_amount" className="form-label d-block w-100 mb-2" style={{ color: "#777", fontSize: "14px", fontWeight: 500 }}>
              Amount <span className="errorMsg">*</span>
            </label>

            <TextField
              sx={{ width: "100%" }}
              size="small"
              name="amount"
              type="text"
              inputProps={{ inputMode: "numeric" }}
              placeholder="Enter amount"
              onKeyDown={(e) => {
                if (
                  !/[0-9]/.test(e.key) &&
                  !["Backspace", "Tab", "ArrowLeft", "ArrowRight", "Delete", "Enter"].includes(e.key)
                ) {
                  e.preventDefault();
                }
              }}
              {...register("amount", {
                required: "Amount field is required",
                validate: validatePositiveAmount,
                pattern: {
                  value: /^[0-9]+$/,
                  message: "Only numbers are allowed",
                },
                onChange: (e) => {
                  e.target.value = e.target.value.replace(/[^0-9]/g, "");
                },
              })}
            />
            {errors.amount && (
              <p className="errorMsg">{errors.amount.message}</p>
            )}
          </div>
        </div>
        <div className="d-flex p-3 align-items-center position-absolute bottom-0 w-100 bg-white gap-3">
          <button
            type="submit"
            className="add_btn"
            disabled={loading}
            onClick={onapply}
          >
            {loading ? "Adding..." : "Add"}
          </button>
          <button className="cancel_btn" type="button" onClick={oncancel}>
            Cancel
          </button>
        </div>
      </form>
    </>
  );
};

// //console.log("API Response:", data);                                                                                                         
export const BudgetTable = ({
  filteredData,
  initialGroupedData,
  isInvalidDateRange,
  isDateFilterActive,
  projectStartDate,
}) => {
  const { isDarkMode } = useTheme();
  //console.log("API Response (filteredData):", filteredData);

  const formatDate = (dateStr) => {
    if (!dateStr || dateStr === "No Data") return "No Data";
    const parsed = dayjs(dateStr);
    return parsed.isValid() && parsed.year() >= 1900 ? parsed.format("DD/MM/YYYY") : "No Data";                          
  };

  // Check if data exists
  const groupedData = filteredData?.data?.grouped_data || {};
  const hasData = Object.keys(groupedData).length > 0;

  // Show "No Data Found" or "Invalid Date Selected" inside Table if there's no data
  if (!hasData) {
    return (
      <Box
        sx={{
          overflowX: "auto",
          border: isDarkMode ? "1px solid #333" : "1px solid #e0e0e0",
          width: "100%",
          marginBottom: 2,
        }}
      >
        <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell style={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }}>S.No</TableCell>
              <TableCell style={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }}>Name</TableCell>
              <TableCell style={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }}>Hours</TableCell>
              <TableCell style={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }}>Rate / hr</TableCell>
              <TableCell style={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }}>Start Date</TableCell>
              <TableCell style={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }}>End Date</TableCell>
              <TableCell style={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }}>Total Hrs</TableCell>
              <TableCell style={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }}>Total Amount</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell colSpan={8} align="center" sx={{ py: 3 }}>
                <Typography
                  variant="subtitle1"
                  color={isInvalidDateRange ? "textBlack" : "textSecondary"}
                  sx={{ fontWeight: 600 }}
                >
                  {isInvalidDateRange ? "Invalid Date Selected" : "No Data Found"}
                </Typography>
                {(isDateFilterActive || isInvalidDateRange) && (
                  <Typography variant="body2" color="textSecondary" sx={{ mt: 0.5 }}>
                    {isInvalidDateRange
                      ? "The to date field must be a date after or equal to from date."
                      : "No matching records found for the selected date range"}
                  </Typography>
                )}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      </Box>
    );
  }

  const parseTimeToDecimalHours = (hoursVal) => {
    if (!hoursVal || hoursVal === "No Data") return 0;
    const str = String(hoursVal).trim();
    if (str.includes(":") || str.includes(".")) {
      const parts = str.split(/[.:]/);
      const h = parseFloat(parts[0]) || 0;
      const m = parseFloat(parts[1]) || 0;
      return h + m / 60;
    }
    const num = parseFloat(str);
    return isNaN(num) ? 0 : num;
  };

  // Transform API data for rendering
  let calculatedOverallTotal = 0;
  const data = Object.entries(groupedData).map(([id, group]) => {
    const { name, rates, user_id } = group;
    const overallTotalAmount = group?.rates?.total_amount || 0;
    const overallTotalHours = group?.rates?.total_hours || 0;

    let originalUserGroup = null;
    if (Array.isArray(initialGroupedData)) {
      originalUserGroup = initialGroupedData.find(
        (u) =>
          (user_id && u.user_id === user_id) ||
          (name && u.name === name)
      );
    } else if (initialGroupedData && typeof initialGroupedData === "object") {
      originalUserGroup =
        initialGroupedData[id] ||
        Object.values(initialGroupedData).find(
          (u) =>
            (user_id && u.user_id === user_id) ||
            (name && u.name === name)
        );
    }

    const rows =
      rates?.details?.length > 0
        ? rates.details.map((detail, detailIdx) => {
            const originalDetail =
              originalUserGroup?.rates?.details?.[detailIdx] ||
              originalUserGroup?.rates?.details?.[0];
            const rawStartDate =
              detail?.actual_start_date ||
              detail?.original_start_date ||
              originalDetail?.start_date ||
              detail?.start_date;
            const rawEndDate =
              detail?.actual_end_date ||
              detail?.original_end_date ||
              originalDetail?.end_date ||
              detail?.end_date;

            const numRate =
              detail.rate && detail.rate !== "No Data" && !isNaN(detail.rate)
                ? Number(detail.rate)
                : 0;
            const numHours = parseTimeToDecimalHours(detail.hours);
            const calculatedRowAmount = numHours * numRate;
            calculatedOverallTotal += calculatedRowAmount;

            // Direct mapping from backend response (Single Source of Truth)
            let rowAmountDisplay = "0.00";
            if (!detail.rate || detail.rate === "No Data" || isNaN(detail.rate)) {
              rowAmountDisplay = "0.00";
            } else if (detail.amount !== undefined && detail.amount !== null) {
              rowAmountDisplay =
                typeof detail.amount === "number"
                  ? formatINR(detail.amount)
                  : detail.amount;
            } else if (rates?.details?.length === 1 && rates?.total_amount) {
              rowAmountDisplay =
                typeof rates.total_amount === "number"
                  ? formatINR(rates.total_amount)
                  : rates.total_amount;
            } else {
              rowAmountDisplay = formatINR(calculatedRowAmount);
            }

            return {
              hours: detail.hours || "00.00",
              rate: detail.rate || "No Data",
              startDate: formatDate(rawStartDate),
              endDate: formatDate(rawEndDate),
              totalHrs: detail.hours || "00.00",
              totalAmount: rowAmountDisplay,
            };
          })
        : [
            {
              hours: "00.00",
              rate: "No Data",
              startDate: "No Data",
              endDate: "No Data",
              totalHrs: "00.00",
              totalAmount: "0.00",
            },
          ];

    return {
      id,
      name: name || "No Data",
      rows,
      totalHours: overallTotalHours,
      totalAmount: overallTotalAmount,
    };
  });

  //console.log("Transformed Data for Table Rendering:", data);

  return (
    <Box
      sx={{
        overflowX: "auto",
        border: isDarkMode ? "1px solid #333" : "1px solid #e0e0e0",
        width: "100%",
        marginBottom: 2,
      }}
    >
      <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
      <Table stickyHeader>
        <TableHead>
          <TableRow
            sx={{
              position: "sticky",
              top: 0,
              zIndex: 2,
              // backgroundColor: "#fff",
            }}
          >
            <TableCell style={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }}>S.No</TableCell>
            <TableCell style={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }}>Name</TableCell>
            <TableCell style={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }}>Hours</TableCell>
            <TableCell style={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }}>Rate / hr</TableCell>
            <TableCell style={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }}>Start Date</TableCell>
            <TableCell style={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }}>End Date</TableCell>
            <TableCell style={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }}>Total Hrs</TableCell>
            <TableCell style={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }}>Total Amount</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((group, groupIndex) => (
            <React.Fragment key={group.id}>
              {group.rows.map((row, rowIndex) => (
                <TableRow key={`${group.id}-${rowIndex}`}>
                  {rowIndex === 0 && (
                    <>
                      <TableCell rowSpan={group.rows.length}>
                        {groupIndex + 1}
                      </TableCell>
                      <TableCell rowSpan={group.rows.length}>
                        {group.name}
                      </TableCell>
                    </>
                  )}
                  {(() => {
                    const isUnassigned =
                      row.rate === "No Data" ||
                      row.rate === null ||
                      row.rate === undefined;
                    const mutedColor = isUnassigned ? "#888" : undefined;

                    return (
                      <>
                        <TableCell sx={mutedColor ? { color: mutedColor } : {}}>
                          {row.hours}
                        </TableCell>
                        <TableCell>
                          {isUnassigned ? (
                            <span style={{ whiteSpace: "nowrap", color: "#d32f2f", fontWeight: 500 }}>
                              No Data (0)
                            </span>
                          ) : (
                            formatINR(row.rate, { minimumFractionDigits: 0 })
                          )}
                        </TableCell>
                        <TableCell>
                          {row.startDate === "No Data" || !row.startDate ? (
                            <span style={{ whiteSpace: "nowrap", color: "#d32f2f", fontWeight: 500 }}>
                              No Data
                            </span>
                          ) : (
                            row.startDate
                          )}
                        </TableCell>
                        <TableCell>
                          {row.endDate === "No Data" || !row.endDate ? (
                            <span style={{ whiteSpace: "nowrap", color: "#d32f2f", fontWeight: 500 }}>
                              No Data
                            </span>
                          ) : (
                            row.endDate
                          )}
                        </TableCell>
                        <TableCell sx={mutedColor ? { color: mutedColor } : {}}>
                          {row.totalHrs}
                        </TableCell>
                        <TableCell sx={mutedColor ? { color: mutedColor } : {}}>
                          {formatINR(row.totalAmount)}
                        </TableCell>
                      </>
                    );
                  })()}
                </TableRow>
              ))}
            </React.Fragment>
          ))}

          {/* Overall Total Row */}
          <TableRow
            sx={{
              position: "sticky",
              bottom: 0,
              zIndex: 2,
              backgroundColor: "var(--cell-bg-color)",
            }}
          >
            <TableCell colSpan={7} align="right">
              <Typography fontWeight="bold">Overall Total Amount</Typography>
            </TableCell>
            <TableCell>
              <Typography fontWeight="bold">
                {formatINR(filteredData?.data?.overall_total_amount || calculatedOverallTotal)}
              </Typography>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
    </Box>
  );
};

export const FixedExpenses = () => {
  const { isDarkMode } = useTheme();
  const project_id = localStorage.getItem("project_id");
  const [expenses, setExpenses] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const { data, isLoading, refetch } = useFetchBudgetExpenseTableQuery(project_id, {
    refetchOnMountOrArgChange: true,
  });

  useEffect(() => {
    if (refetch) refetch();
  }, [project_id, refetch]);
  const viewAllExpense = async () => {
    try {
      if (data && data.expenses) {
        setExpenses(data.expenses);
        setTotalAmount(data.total_amount || 0);
      } else {
        setExpenses([]);
        setTotalAmount(0);
      }
    } catch (err) {
      const errorMsg = err.message;
      toast.error(errorMsg);
    }
  };
  useEffect(() => {
    viewAllExpense();
  }, [data]);

  const parseAmt = (val) => typeof val === "number" ? val : (parseFloat(String(val || 0).replace(/,/g, "")) || 0);

  return (
    <Box
      sx={{
        overflowX: "auto",
        border: isDarkMode ? "1px solid #333" : "1px solid #e0e0e0",
        width: "100%",
        marginBottom: 2,
      }}
    >
      <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell align="center" style={{ backgroundColor: "#f5f5f5", fontWeight: "bold", width: "80px" }}>S.No</TableCell>
              <TableCell align="left" colSpan={2} style={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }}>
                Remarks
              </TableCell>
              <TableCell align="right" style={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }}>Amount</TableCell>
              <TableCell align="right" style={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }} sx={{ pr: 4 }}>Total Amount</TableCell>
            </TableRow>
          </TableHead>
          {isLoading ? (
            <Loader />
          ) : (
            <TableBody>
              {expenses.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    <Typography variant="subtitle1" color="textSecondary" sx={{ py: 2 }}>
                      No Data Found
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : (
                expenses.map((fixedExpense, index) => (
                  <TableRow key={fixedExpense.fixed_expense_id || index}>
                    <TableCell align="center">{`0${fixedExpense.fixed_expense_id}`}</TableCell>
                    <TableCell align="left" colSpan={2}>
                      {fixedExpense.comments || "-"}
                    </TableCell>
                    <TableCell align="right">
                      {formatINR(parseAmt(fixedExpense.amount))}
                    </TableCell>
                    <TableCell align="right" sx={{ pr: 4 }}>
                      {formatINR(parseAmt(fixedExpense.amount))}
                    </TableCell>
                  </TableRow>
                ))
              )}

              {/* Sticky Total Row */}
              {expenses.length > 0 && (
                <TableRow
                  sx={{
                    position: "sticky",
                    bottom: 0,
                    backgroundColor: "var(--cell-bg-color)",
                    zIndex: 1,
                  }}
                >
                  <TableCell colSpan={5} align="right" sx={{ pr: 4 }}>
                    <Box className="d-flex align-items-center justify-content-end gap-3">
                      <Typography fontWeight="bold" sx={{ mr: "7px" }}>Total Amount</Typography>
                      <Typography fontWeight="bold">
                        {formatINR(parseAmt(totalAmount))}
                      </Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          )}
        </Table>
      </TableContainer>
    </Box>
  );
};

export const SummaryTable = ({ additionalScopes = [], refreshKey = 0 }) => {
  const { isDarkMode } = useTheme();
  const [paymentsExpanded, setPaymentsExpanded] = useState(false);
  const [additionalExpanded, setAdditionalExpanded] = useState(false);
  const [showScopeReceipt, setShowScopeReceipt] = useState(false);
  const [summaryList, setSummaryList] = useState([]);
  const [originalBudgetState, setOriginalBudgetState] = useState(0);
  const [additionalAmountState, setAdditionalAmountState] = useState(0);
  const [revisedBudgetState, setRevisedBudgetState] = useState(0);
  const project_id = localStorage.getItem("project_id");
  const { data, refetch, currentData, isLoading } =
    useFetchBudgetSummaryTableQuery(project_id, {
      refetchOnMountOrArgChange: true,
    });

  const parseAmount = (val) => {
    if (typeof val === "number") return val;
    if (typeof val === "string") {
      return parseFloat(val.replace(/,/g, "")) || 0;
    }
    return 0;
  };

  const viewAllPayments = async () => {
    try {
      if (data) {

        const cleanStr = (str) => {
          if (!str) return "";
          return str.replace(/\u00a0/g, " ").replace(/\s+/g, " ").trim().toLowerCase();
        };

        // Calculate additional scope total
        const scopesArray = Array.isArray(additionalScopes) ? additionalScopes : [];
        const additionalAmount = scopesArray.reduce((sum, item) => sum + parseAmount(item.amount), 0);

        // Find initial values from API data
        const budgetObj = data.find(row => cleanStr(row.label) === "budget");
        const rawApiBudget = budgetObj ? parseAmount(budgetObj.totalAmount) : 0;
        
        // Base Contract Budget stays constant (Project Details initial budget)
        const originalBudget = rawApiBudget >= additionalAmount ? rawApiBudget - additionalAmount : rawApiBudget;
        
        const expensesObj = data.find(row => cleanStr(row.label) === "total expenses");
        const totalExpenses = expensesObj ? parseAmount(expensesObj.totalAmount) : 0;
        
        const paymentsReceivedObj = data.find(row => cleanStr(row.label) === "payments received");
        const paymentsReceived = paymentsReceivedObj ? parseAmount(paymentsReceivedObj.totalAmount) : 0;

        // Calculate revised values (Base Budget + Additional Scope)
        const revisedBudget = originalBudget + additionalAmount;
        const revisedProfit = revisedBudget - totalExpenses;
        const revisedProfitPercent = revisedBudget !== 0 ? (revisedProfit / revisedBudget) * 100 : 0;
        const revisedPaymentsPending = revisedBudget - paymentsReceived;
        const revisedPercentReceived = revisedBudget !== 0 ? (paymentsReceived / revisedBudget) * 100 : 0;

        setOriginalBudgetState(originalBudget);
        setAdditionalAmountState(additionalAmount);
        setRevisedBudgetState(revisedBudget);

        // Format function helper for formulas
        const fmt = (num) => formatINR(num);

        const updatedList = data.map((row) => {
          let totalAmount = row.totalAmount;
          let formula = "";
          let color = row.color;
          const cleanLabel = cleanStr(row.label);

          if (cleanLabel === "total expenses") {
            formula = "Budget Hours Total + Fixed Expenses";
          } else if (cleanLabel === "budget") {
            if (additionalAmount > 0) {
              totalAmount = revisedBudget;
              formula = `${fmt(originalBudget)} + ${fmt(additionalAmount)} (Add. Scope)`;
              return {
                ...row,
                totalAmount,
                formula,
                color,
                original_budget: originalBudget,
                additional_scopes: scopesArray,
              };
            } else {
              formula = "Base Contract Budget";
            }
          } else if (cleanLabel === "profit") {
            totalAmount = revisedProfit;
            color = revisedProfit >= 0 ? "green" : "red";
            if (additionalAmount > 0) {
              formula = `${fmt(revisedBudget)} (Revised Budget) - ${fmt(totalExpenses)} (Expenses)`;
            } else {
              formula = `${fmt(originalBudget)} (Budget) - ${fmt(totalExpenses)} (Expenses)`;
            }
          } else if (cleanLabel === "profit %" || cleanLabel.includes("profit %") || cleanLabel.includes("profit%")) {
            totalAmount = `${revisedProfitPercent.toFixed(2)}%`;
            color = revisedProfit >= 0 ? "green" : "red";
            if (additionalAmount > 0) {
              formula = `(${fmt(revisedProfit)} Profit / ${fmt(revisedBudget)} Revised Budget) * 100`;
            } else {
              formula = `(${fmt(revisedProfit)} Profit / ${fmt(originalBudget)} Budget) * 100`;
            }
          } else if (cleanLabel === "payments received") {
            formula = "Received amount";
          } else if (cleanLabel === "payments pending") {
            totalAmount = revisedPaymentsPending;
            if (additionalAmount > 0) {
              formula = `${fmt(revisedBudget)} (Revised Budget) - ${fmt(paymentsReceived)} (Received)`;
            } else {
              formula = `${fmt(originalBudget)} (Budget) - ${fmt(paymentsReceived)} (Received)`;
            }
          } else if (cleanLabel.includes("% based on") || cleanLabel.includes("payment received")) {
            totalAmount = `${revisedPercentReceived.toFixed(2)}%`;
            if (additionalAmount > 0) {
              formula = `(${fmt(paymentsReceived)} Received / ${fmt(revisedBudget)} Revised Budget) * 100`;
            } else {
              formula = `(${fmt(paymentsReceived)} Received / ${fmt(originalBudget)} Budget) * 100`;
            }
          }

          return {
            ...row,
            totalAmount,
            formula,
            color,
          };
        });

        setSummaryList(updatedList);
      } else {
        setSummaryList([]);
      }
    } catch (error) {
      console.error("Error fetching summary data:", error);
      setSummaryList([]);
    }
  };

  useEffect(() => {
    if (refetch) refetch();
  }, [project_id, refreshKey, refetch]);

  useEffect(() => {
    viewAllPayments();
  }, [data, additionalScopes]);



  return (
    <Box
      sx={{
        overflowX: "auto",
        borderRadius: "4px",
        marginTop: 2,
        marginRight: "150px",
      }}
    >
      <TableContainer
        component={Paper}
        sx={{ boxShadow: "none", transitionDelay: 200, transition: "2s ease" }}
      >
        <Table>
          <TableHead>
            <TableRow>
              <TableCell
                colSpan={3}
                sx={{ backgroundColor: "#f5f5f5", textAlign: "center" }}
              >
                <Typography align="right" fontWeight="bold"></Typography>
              </TableCell>

              <TableCell
                sx={{
                  backgroundColor: "#f5f5f5",
                  textAlign: "center",
                }}
              >
                <Typography
                  align="center"
                  textTransform="capitalize"
                  fontWeight="bold"
                >
                  Total Hrs
                </Typography>
              </TableCell>

              <TableCell
                sx={{
                  backgroundColor: "#f5f5f5",
                  textAlign: "left",
                }}
              >
                <Typography
                  textTransform="capitalize"
                  fontWeight="bold"
                  align="left"
                >
                  Calculation
                </Typography>
              </TableCell>

              <TableCell
                sx={{
                  backgroundColor: "#f5f5f5",
                  textAlign: "right",
                }}
              >
                <Typography
                  textTransform="capitalize"
                  fontWeight="bold"
                  align="right"
                >
                  Amount
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          
          <TableBody>
            {Array.isArray(summaryList) &&
              summaryList.map((row, index) => (
                <React.Fragment key={index}>
                  <TableRow>
                    <TableCell colSpan={3} align="right">
                      {row.label === "Payments Received" && (
                        <IconButton
                          onClick={() => setPaymentsExpanded(!paymentsExpanded)}
                          size="small"
                          sx={{
                            color: isDarkMode ? "#e0e0e0" : "#555",
                            transition: "all 0.25s ease-in-out",
                            "&:hover": {
                              backgroundColor: isDarkMode ? "rgba(255, 255, 255, 0.12)" : "rgba(0, 0, 0, 0.08)",
                              color: isDarkMode ? "#ffffff" : "#333",
                            },
                          }}
                        >
                          <ExpandMoreIcon
                            sx={{ 
                              transform: paymentsExpanded
                                ? "rotate(180deg)"
                                : "rotate(0deg)",
                              transition: "transform 0.3s ease-in-out",
                            }}
                          />
                        </IconButton>
                      )}
                      {row.additional_scopes && row.additional_scopes.length > 0 && (
                        <>
                          <IconButton
                            onClick={() => setAdditionalExpanded(!additionalExpanded)}
                            size="small"
                            sx={{
                              color: isDarkMode ? "#e0e0e0" : "#555",
                              transition: "all 0.25s ease-in-out",
                              "&:hover": {
                                backgroundColor: isDarkMode ? "rgba(255, 255, 255, 0.12)" : "rgba(0, 0, 0, 0.08)",
                                color: isDarkMode ? "#ffffff" : "#333",
                              },
                            }}
                          >
                            <ExpandMoreIcon
                              sx={{ 
                                transform: additionalExpanded
                                  ? "rotate(180deg)"
                                  : "rotate(0deg)",
                                transition: "transform 0.3s ease-in-out",
                              }}
                            />
                          </IconButton>
                          <IconButton
                            onClick={() => setShowScopeReceipt(true)}
                            size="small"
                            sx={{
                              color: isDarkMode ? "#12b79f" : "#04a189",
                              mr: 0.5,
                              transition: "all 0.25s ease-in-out",
                              "&:hover": {
                                backgroundColor: isDarkMode ? "rgba(255, 255, 255, 0.12)" : "rgba(0, 0, 0, 0.08)",
                                color: isDarkMode ? "#12b79f" : "#04a189",
                              },
                            }}
                          >
                            <InfoOutlinedIcon fontSize="small" />
                          </IconButton>
                        </>
                      )}
                      {row.label}
                    </TableCell>
                    <TableCell align="center">{row.total_hours}</TableCell>
                    <TableCell align="left" sx={{ color: isDarkMode ? "#aaa" : "#777", fontSize: "13px" }}>
                      {row.formula || ""}
                    </TableCell>
                    <TableCell
                      align="right"
                      sx={{ color: row.color || "inherit" }}
                    >
                      {String(row.label ?? "").includes("%") ? row.totalAmount : formatINR(row.totalAmount)}
                    </TableCell>
                  </TableRow>
                  {row.payments_received && (
                    <TableRow>
                      <TableCell
                        colSpan={6}
                        sx={{
                          paddingBottom: 0,
                          paddingTop: 0,
                          backgroundColor: "var(--cell-bg-color)",
                        }}
                      >
                        <Collapse in={paymentsExpanded} timeout="auto" unmountOnExit>
                          <Box sx={{ margin: 1 }}>
                            <Table>
                              <TableBody>
                                {row.payments_received.map(
                                  (payment, paymentIndex) => (
                                    <TableRow key={paymentIndex}>
                                      <TableCell
                                        colSpan={5}
                                        align="center"
                                        sx={{
                                          fontSize: "14px",
                                          fontWeight: "normal",
                                          px: 2,
                                        }}
                                      >
                                         {`${payment.invoice_number ? `${payment.invoice_number} - ` : ""}${payment.name}${payment.added_at ? ` - ${dayjs(payment.added_at).isValid() ? dayjs(payment.added_at).format(payment.added_at.includes(":") ? "DD/MM/YYYY hh:mm A" : "DD/MM/YYYY") : payment.added_at}` : ""}`}
                                      </TableCell>

                                      <TableCell
                                        align="right"
                                        sx={{
                                          fontSize: "14px",
                                          fontWeight: "normal",
                                          pr: 3,
                                        }}
                                      >
                                        {formatINR(payment.amount)}
                                      </TableCell>
                                    </TableRow>
                                  )
                                )}
                              </TableBody>
                            </Table>
                          </Box>
                        </Collapse>
                      </TableCell>
                    </TableRow>
                  )}
                  {row.additional_scopes && row.additional_scopes.length > 0 && (
                    <TableRow>
                      <TableCell
                        colSpan={6}
                        sx={{
                          paddingBottom: 0,
                          paddingTop: 0,
                          backgroundColor: "var(--cell-bg-color)",
                        }}
                      >
                        <Collapse in={additionalExpanded} timeout="auto" unmountOnExit>
                          <Box sx={{ margin: 1 }}>
                            <Table>
                              <TableBody>
                                 <TableRow
                                  sx={{
                                    backgroundColor: isDarkMode
                                      ? "rgba(18, 183, 159, 0.08)"
                                      : "#f4fbf9",
                                    border: isDarkMode
                                      ? "1px solid rgba(18, 183, 159, 0.25)"
                                      : "1px solid rgba(4, 161, 137, 0.2)",
                                  }}
                                >
                                  <TableCell
                                    colSpan={5}
                                    align="center"
                                    sx={{
                                      fontSize: "14px",
                                      fontWeight: "bold",
                                      px: 2,
                                      color: isDarkMode ? "#12b79f" : "#04a189",
                                      wordBreak: "keep-all",
                                    }}
                                  >
                                    Initial Contract Budget
                                  </TableCell>
                                  
                                  <TableCell
                                    align="right"
                                    sx={{
                                      fontSize: "14px",
                                      fontWeight: "bold",
                                      pr: 3,
                                      color: isDarkMode ? "#12b79f" : "#04a189",
                                    }}
                                  >
                                    {formatINR(row.original_budget || originalBudgetState)}
                                  </TableCell>
                                </TableRow>
                                {row.additional_scopes.map(
                                  (item, itemIndex) => (
                                    <TableRow key={itemIndex}>
                                      <TableCell
                                        colSpan={5}
                                        align="center"
                                        sx={{
                                          fontSize: "14px",
                                          fontWeight: "normal",
                                          px: 2,
                                          wordBreak: "keep-all",
                                          whiteSpace: "normal",
                                        }}
                                      >
                                        {`${item.type} - ${item.remarks}${item.approved_date ? ` - ${dayjs(item.approved_date).isValid() ? dayjs(item.approved_date).format("DD/MM/YYYY") : item.approved_date}` : ""}`}
                                      </TableCell>

                                      <TableCell
                                        align="right"
                                        sx={{
                                          fontSize: "14px",
                                          fontWeight: "normal",
                                          pr: 3,
                                        }}
                                      >
                                        {formatINR(parseAmount(item.amount))}
                                      </TableCell>
                                    </TableRow>
                                  )
                                )}
                              </TableBody>
                            </Table>
                          </Box>
                        </Collapse>
                      </TableCell>
                    </TableRow>
                  )}
                </React.Fragment>
              ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Additional Scope Receipt Offcanvas */}
      <Offcanvas placement="end" show={showScopeReceipt} onHide={() => setShowScopeReceipt(false)} style={{ width: "40%" }}>
        <OffcanvasBody style={{ backgroundColor: isDarkMode ? "#121212" : "#fff", color: isDarkMode ? "#fff" : "#000" }}>
          <div className="d-flex gap-1 align-items-center mt-1 mb-4" onClick={() => setShowScopeReceipt(false)} style={{ cursor: "pointer" }}>
            <IoIosArrowBack style={{ color: isDarkMode ? "#fff" : "#000" }} />
            <Typography sx={{ fontWeight: "bold", fontSize: "16px", color: isDarkMode ? "#fff" : "#000" }}>
              Budget & Additional Scope Receipt
            </Typography>
          </div>

          <div
            className="p-4"
            style={{
              backgroundColor: isDarkMode ? "#1e1e1e" : "#fff",
              border: isDarkMode ? "1px solid #333" : "1px solid #eaeaea",
              borderRadius: "12px",
              boxShadow: isDarkMode ? "0px 4px 12px rgba(0, 0, 0, 0.3)" : "0px 4px 12px rgba(0, 0, 0, 0.05)",
            }}
          >
            <div className="text-center mb-4 pb-3" style={{ borderBottom: isDarkMode ? "2px solid #12b79f" : "2px solid #04a189" }}>
              <Typography variant="h6" sx={{ fontWeight: "bold", color: isDarkMode ? "#12b79f" : "#04a189", letterSpacing: "1px" }}>
                BUDGET STATEMENT RECEIPT
              </Typography>
              <Typography variant="caption" sx={{ color: isDarkMode ? "#aaa" : "#969696", textTransform: "uppercase", fontSize: "11px", fontWeight: 500 }}>
                Accounting Audit Log
              </Typography>
            </div>

            {/* Base contract budget */}
            <div className="d-flex justify-content-between py-2">
              <Typography sx={{ fontWeight: 600, color: isDarkMode ? "#fff" : "#444" }}>Initial Contract Budget</Typography>
              <Typography sx={{ fontWeight: "bold", color: isDarkMode ? "#fff" : "#444" }}>
                {formatINR(originalBudgetState)}
              </Typography>
            </div>

            <div style={{ borderTop: isDarkMode ? "1px dashed #444" : "1px dashed #ccc", margin: "10px 0" }}></div>

            {/* Column Names: Requirement / Remarks and Amount */}
            <div className="d-flex justify-content-between py-1 mb-2">
              <Typography sx={{ fontWeight: "bold", fontSize: "12px", color: isDarkMode ? "#aaa" : "#969696", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                Requirement / Type
              </Typography>
              <Typography sx={{ fontWeight: "bold", fontSize: "12px", color: isDarkMode ? "#aaa" : "#969696", textTransform: "uppercase", letterSpacing: "0.5px", textAlign: "right" }}>
                Amount
              </Typography>
            </div>

            {/* Additional Scopes list */}
            <div className="my-3">
              {!Array.isArray(additionalScopes) || additionalScopes.length === 0 ? (
                <div className="text-center py-3 text-muted" style={{ fontStyle: "italic", fontSize: "14px", color: isDarkMode ? "#aaa" : "#888" }}>
                  No additional scopes added.
                </div>
              ) : (
                <div className="d-flex flex-column gap-3">
                  {additionalScopes.map((item, idx) => {
                    const amount = parseAmount(item.amount);
                    return (
                      <div key={idx} className="d-flex justify-content-between align-items-start">
                        <div className="d-flex flex-column">
                          <Typography sx={{ fontWeight: 600, fontSize: "14px", color: isDarkMode ? "#eee" : "#555" }}>
                            {item.type} {item.approved_date ? `(${dayjs(item.approved_date).format("DD/MM/YYYY")})` : ""}
                          </Typography>
                          <Typography sx={{ color: isDarkMode ? "#aaa" : "#777", fontSize: "13px" }}>
                            Remarks: {item.remarks}
                          </Typography>
                        </div>
                        <Typography sx={{ fontWeight: 600, color: isDarkMode ? "#4caf50" : "green", fontSize: "14px" }}>
                          +{formatINR(amount)}
                        </Typography>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>

            <div style={{ borderTop: isDarkMode ? "1px dashed #444" : "1px dashed #ccc", margin: "15px 0" }}></div>

            {/* Scope additions total sum */}
            <div className="d-flex justify-content-between py-2">
              <Typography sx={{ fontWeight: 500, color: isDarkMode ? "#ccc" : "#666", fontSize: "14px" }}>Total Additional Scope</Typography>
              <Typography sx={{ fontWeight: 600, color: isDarkMode ? "#4caf50" : "green", fontSize: "14px" }}>
                +{formatINR(additionalAmountState)}
              </Typography>
            </div>

            <div style={{ borderTop: isDarkMode ? "1px dashed #444" : "1px dashed #ccc", margin: "15px 0" }}></div>

            {/* Total revised summary */}
            <div className="d-flex justify-content-between align-items-center py-2">
              <Typography sx={{ fontWeight: "bold", color: isDarkMode ? "#fff" : "#111", fontSize: "16px" }}>Total Revised Budget</Typography>
              <Typography sx={{ fontWeight: "bold", color: isDarkMode ? "#12b79f" : "#04a189", fontSize: "20px" }}>
                {formatINR(revisedBudgetState)}
              </Typography>
            </div>
            
            <div style={{ borderTop: isDarkMode ? "1px dashed #444" : "1px dashed #ccc", margin: "15px 0" }}></div>

            {/* Formula display: Initial Budget + Additional Scope = Total Budget */}
            <div
              className="p-3 my-2 rounded text-center"
              style={{
                backgroundColor: isDarkMode ? "rgba(18, 183, 159, 0.08)" : "rgba(4, 161, 137, 0.05)",
                border: isDarkMode ? "1px dashed rgba(18, 183, 159, 0.3)" : "1px dashed #ccc",
              }}
            >
              <Typography sx={{ fontSize: "11px", color: isDarkMode ? "#aaa" : "#888", fontWeight: "bold", mb: 0.5, textTransform: "uppercase", letterSpacing: "0.5px" }}>
                Calculation Formula
              </Typography>
              <Typography sx={{ fontSize: "13px", fontWeight: "bold", color: isDarkMode ? "#fff" : "#333", mb: 1 }}>
                Initial Budget + Additional Scope = Total Budget
              </Typography>
              <Typography sx={{ fontSize: "12px", color: isDarkMode ? "#12b79f" : "#04a189", fontWeight: "bold" }}>
                {formatINR(originalBudgetState)} + {formatINR(additionalAmountState)} = {formatINR(revisedBudgetState)}
              </Typography>
            </div>
          </div>
        </OffcanvasBody>
      </Offcanvas>
    </Box>
  );
};

export const PaymentsReceived = () => {
  const { isDarkMode } = useTheme();
  const [payment, setPayment] = useState([]);
  const project_id = localStorage.getItem("project_id");
  const { data, refetch, isLoading } = useFetchBudgetPaymentsQuery(project_id, {
    refetchOnMountOrArgChange: true,
  });
  
  const [showEditPayment, setShowEditPayment] = useState(false);
  const [editPaymentItem, setEditPaymentItem] = useState(null);
  const [deletePaymentItem, setDeletePaymentItem] = useState(null);
  const [deleteBudgetPayment] = useDeleteBudgetPaymentMutation();
  const deleteManualInvoiceHookResult = useDeleteManualInvoiceMutation();
  const deleteManualInvoice = Array.isArray(deleteManualInvoiceHookResult) ? deleteManualInvoiceHookResult[0] : null;

  const { data: summaryData, refetch: summaryRefetch } = useFetchBudgetSummaryTableQuery(project_id);

  const handleEdit = (item) => {
    setEditPaymentItem(item);
    setShowEditPayment(true);
  };

  const handleDelete = async () => {
    if (deletePaymentItem) {
      try {
        const isInvoicePayment = Boolean(deletePaymentItem.invoice_id);
        const rawSource = String(deletePaymentItem.source || "").toUpperCase();
        const isManual =
          isInvoicePayment &&
          (rawSource === "MANUAL" ||
            rawSource === "CASH" ||
            rawSource === "MANINV" ||
            String(deletePaymentItem.invoice_number || "").toUpperCase().startsWith("MAN") ||
            String(deletePaymentItem.comments || "").toUpperCase().includes("MANUAL"));

        if (isManual) {
          const response = await deleteManualInvoice(deletePaymentItem.invoice_id).unwrap();
          if (response && response.status) {
            toast.success(response.message || "Manual invoice and payment deleted successfully");
            setDeletePaymentItem(null);
            refetch();
            summaryRefetch();
          } else {
            toast.error(response?.message || "Failed to delete manual invoice");
          }
        } else {
          const response = await deleteBudgetPayment({
            project_id,
            payment_id: deletePaymentItem.payments_received_id,
          }).unwrap();
          if (response && response.status) {
            toast.success(response.message || "Payment deleted successfully");
            setDeletePaymentItem(null);
            refetch();
            summaryRefetch();
          } else {
            toast.error(response?.message || "Failed to delete payment");
          }
        }
      } catch (err) {
        toast.error(err?.data?.message || err?.message || "Error deleting payment");
      }
    }
  };

  useEffect(() => {
    if (refetch) refetch();
  }, [project_id, refetch]);

  useEffect(() => {
    const viewAllPayments = async () => {
      if (data) {
        setPayment(data.payments);
      }
    };
    viewAllPayments();
  }, [data]);

  const parseAmt = (val) => typeof val === "number" ? val : (parseFloat(String(val || 0).replace(/,/g, "")) || 0);

  const totalPaymentAmount = payment && payment.length > 0
    ? payment.reduce((acc, curr) => acc + parseAmt(curr.amount), 0)
    : 0;

  return (
    <Box
      sx={{
        overflowX: "auto",
        border: isDarkMode ? "1px solid #333" : "1px solid #e0e0e0",
        width: "100%",  // 100% payment received table width
        marginBottom: 2,
      }}
    >
      <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell align="center" style={{ backgroundColor: "#f5f5f5", fontWeight: "bold", width: "80px" }}>
                S.No
              </TableCell>
              <TableCell align="left" style={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }}>
                Remarks
              </TableCell>
              <TableCell align="left" style={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }}>
                Added At
              </TableCell>
              <TableCell align="right" style={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }}>
                Amount
              </TableCell>
              <TableCell align="center" style={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }}>
                Action
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {isLoading ? (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  <Typography variant="subtitle1" color="textSecondary" sx={{ py: 2 }}>
                    Loading...
                  </Typography>
                </TableCell>
              </TableRow>
            ) : !payment || payment.length === 0 ? (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  <Typography variant="subtitle1" color="textSecondary" sx={{ py: 2 }}>
                    No Payments Received Found
                  </Typography>
                </TableCell>
              </TableRow>
            ) : (
              <>
                {payment.map((paymentItem, index) => {
                  let formattedAddedAt = "-";
                  if (paymentItem.added_at) {
                    const d = dayjs(paymentItem.added_at);
                    if (d.isValid()) {
                      formattedAddedAt = d.format("DD/MM/YYYY - hh:mm A");
                    } else {
                      const parts = paymentItem.added_at.split(" ");
                      if (parts.length >= 2) {
                        const datePart = dayjs(parts[0]).isValid() ? dayjs(parts[0]).format("DD/MM/YYYY") : parts[0];
                        const timeParsed = dayjs(`2000-01-01 ${parts[1]}`);
                        const timePart = timeParsed.isValid() ? timeParsed.format("hh:mm A") : parts[1];
                        formattedAddedAt = `${datePart} - ${timePart}`;
                      } else {
                        formattedAddedAt = paymentItem.added_at;
                      }
                    }
                  }

                  return (
                    <TableRow key={paymentItem.payments_received_id || index}>
                      <TableCell align="center">{index + 1}</TableCell>
                      <TableCell align="left">{renderPaymentRemarks(paymentItem.comments)}</TableCell>
                      <TableCell align="left">{formattedAddedAt}</TableCell>
                      <TableCell align="right" sx={{ pr: 4 }}>
                        {formatINR(parseAmt(paymentItem.amount))}
                      </TableCell>
                      <TableCell align="center">
                        {(() => {
                          const isInvoicePayment = Boolean(paymentItem.invoice_id);
                          const rawSource = String(paymentItem.source || "").toUpperCase();
                          const isManual =
                            isInvoicePayment &&
                            (rawSource === "MANUAL" ||
                              rawSource === "CASH" ||
                              rawSource === "MANINV" ||
                              String(paymentItem.invoice_number || "").toUpperCase().startsWith("MAN") ||
                              String(paymentItem.comments || "").toUpperCase().includes("MANUAL"));
                          const invStatus = String(paymentItem.invoice_status || "").toLowerCase();
                          const isMapped = invStatus === "mapped";
                          const isAllocated = invStatus === "allocated";

                          if (isInvoicePayment) {
                            if (isAllocated) {
                              return (
                                <span
                                  className="badge"
                                  style={{
                                    backgroundColor: "rgba(4, 161, 137, 0.08)",
                                    color: "#04a189",
                                    border: "1px solid rgba(4, 161, 137, 0.3)",
                                    borderRadius: "12px",
                                    padding: "4px 10px",
                                    fontSize: "12px",
                                    fontWeight: 500,
                                  }}
                                >
                                  Allocated
                                </span>
                              );
                            }
                            if (isManual && isMapped) {
                              return (
                                <Button
                                  variant="outlined"
                                  color="error"
                                  size="small"
                                  onClick={() => setDeletePaymentItem(paymentItem)}
                                  sx={{ textTransform: "capitalize" }}
                                >
                                  Delete
                                </Button>
                              );
                            }
                            return <span className="text-muted">—</span>;
                          }

                          return (
                            <div className="d-flex gap-2 justify-content-center">
                              <Button
                                variant="outlined"
                                color="primary"
                                size="small"
                                onClick={() => handleEdit(paymentItem)}
                                sx={{ textTransform: "capitalize" }}
                              >
                                Edit
                              </Button>
                              <Button
                                variant="outlined"
                                color="error"
                                size="small"
                                onClick={() => setDeletePaymentItem(paymentItem)}
                                sx={{ textTransform: "capitalize" }}
                              >
                                Delete
                              </Button>
                            </div>
                          );
                        })()}
                      </TableCell>
                    </TableRow>
                  );
                })}

                {/* Total Row */}
                <TableRow
                  sx={{
                    position: "sticky",
                    bottom: 0,
                    backgroundColor: "var(--cell-bg-color)",
                    zIndex: 1,
                  }}
                >
                  <TableCell colSpan={3} align="right">
                    <Typography fontWeight="bold" sx={{ mr: "7px" }}>Total Amount</Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Typography fontWeight="bold">
                      {formatINR(totalPaymentAmount)}
                    </Typography>
                  </TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Edit Payment Offcanvas */}
      <Offcanvas placement="end" show={showEditPayment} style={{ width: "50%" }}>
        <OffcanvasBody className="p-0 position-relative">
          <EditPaymentComponent
            initialData={editPaymentItem}
            oncancel={() => setShowEditPayment(false)}
            onRefetch={() => { refetch(); summaryRefetch(); }}
          />
        </OffcanvasBody>
      </Offcanvas>

      {/* Delete Confirmation Dialog */}
      <Dialog
        open={Boolean(deletePaymentItem)}
        onClose={() => setDeletePaymentItem(null)}
      >
        <DialogTitle sx={{ m: 0, p: 2, pb: 1, fontWeight: "bold" }}>
          {deletePaymentItem?.invoice_id ? "Delete Invoice & Payment" : "Delete Payment"}
        </DialogTitle>
        <DialogContent dividers sx={{ p: 2, width: 400 }}>
          <Typography variant="body1">
            {deletePaymentItem?.invoice_id
              ? `Are you sure you want to delete invoice "${deletePaymentItem?.invoice_number || deletePaymentItem?.comments || ""}"? This will delete both the invoice from Invoice Queue and this payment record.`
              : "Are you sure you want to delete this payment record?"}
          </Typography>
        </DialogContent>
        <DialogActions sx={{ p: 2, pt: 1 }}>
          <Button
            onClick={() => setDeletePaymentItem(null)}
            color="inherit"
            variant="outlined"
            size="small"
            sx={{ textTransform: "capitalize" }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleDelete}
            color="error"
            variant="contained"
            size="small"
            sx={{ textTransform: "capitalize" }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>

    </Box>
  );
};

export const AddScopeComponent = ({ oncancel, onapply, initialData, onRefetch }) => {
  const {
    handleSubmit,
    register,
    control,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      requirement_type: "",
      remarks: "",
      amount: "",
      approved_date: dayjs().format("YYYY-MM-DD"),
      start_date: null,
      end_date: null,
    },
  });
  const [loading, setLoading] = useState(false);
  const [addAdditionalScope] = useAddAdditionalScopeMutation();
  const [updateAdditionalScope] = useUpdateAdditionalScopeMutation();

  const sanitizeDate = (dateStr) => {
    if (!dateStr) return null;
    const d = dayjs(dateStr);
    if (!d.isValid() || d.year() < 1900) return null;
    return d.format("YYYY-MM-DD");
  };

  useEffect(() => {
    if (initialData) {
      const rawAmt = initialData.amount ?? "";
      let cleanAmt = typeof rawAmt === "string" ? rawAmt.replace(/,/g, "") : rawAmt;
      if (cleanAmt !== "" && !isNaN(cleanAmt)) {
        cleanAmt = parseFloat(cleanAmt).toString();
      }
      reset({
        requirement_type: initialData.type || "",
        remarks: initialData.remarks || "",
        amount: cleanAmt,
        approved_date: sanitizeDate(initialData.approved_date) || dayjs().format("YYYY-MM-DD"),
        start_date: sanitizeDate(initialData.start_date),
        end_date: sanitizeDate(initialData.end_date),
      });
    } else {
      reset({
        requirement_type: "",
        remarks: "",
        amount: "",
        approved_date: dayjs().format("YYYY-MM-DD"),
        start_date: null,
        end_date: null,
      });
    }
  }, [initialData, reset]);

  const project_id = localStorage.getItem("project_id");

  const onSubmit = async (data) => {
    setLoading(true);
    const parseAmt = (val) => typeof val === "number" ? val : (parseFloat(String(val || 0).replace(/,/g, "")) || 0);
    const amount = parseAmt(data.amount);
    const payload = {
      type: data.requirement_type,
      approved_date: data.approved_date || dayjs().format("YYYY-MM-DD"),
      start_date: data.start_date || null,
      end_date: data.end_date || null,
      remarks: data.remarks,
      amount: amount,
    };

    try {
      if (initialData && initialData.scope_id) {
        // UPDATE via RTK mutation
        await updateAdditionalScope({ scope_id: initialData.scope_id, payload }).unwrap();
        toast.success("Additional scope updated successfully");
      } 
      else {
        // ADD via RTK mutation
        await addAdditionalScope({ project_id, payload }).unwrap();
        toast.success("Additional scope added successfully");
      }
      if (onRefetch) onRefetch();
      reset();
      oncancel();
    } catch (err) {
      const errorMsg = err?.data?.message || err?.message || "Something went wrong";
      toast.error(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div
        className="d-flex gap-1 align-items-center mt-1"
        onClick={oncancel}
        style={{ cursor: "pointer" }}
      >
        <div>
          <IoIosArrowBack />
        </div>
        <Typography
          sx={{ fontWeight: 500, fontSize: "15px" }}
        >
          {initialData ? "Update Additional Scope & Changes Request" : "Add Additional Scope & Changes Request"}
        </Typography>
      </div>

      <div className="p-4 paddingBtn mt-2">
        <div className="mt-3 mb-3">
          <label htmlFor="requirement_type" className="form-label d-block w-100 mb-2" style={{ color: "#777", fontSize: "14px", fontWeight: 500 }}>
            Select Request Type <span className="errorMsg">*</span>
          </label>
          <div className="w-100">
            <Controller
              name="requirement_type"
              control={control}
              rules={{ required: "Requirement type is required" }}
              render={({ field }) => (
                <FormControl component="fieldset" sx={{ display: "block", width: "100%" }}>
                  <RadioGroup row {...field}>
                    <FormControlLabel
                      value="New Request"
                      control={<Radio sx={{ color: "#ccc", "&.Mui-checked": { color: "#04a189" } }} />}
                      label={<span style={{ fontSize: "14px" }}>New Request</span>}
                    />
                    <FormControlLabel
                      value="Change Request"
                      control={<Radio sx={{ color: "#ccc", "&.Mui-checked": { color: "#04a189" } }} />}
                      label={<span style={{ fontSize: "14px" }}>Change Request</span>}
                    />
                  </RadioGroup>
                </FormControl>
              )}
            />
            {errors.requirement_type && (
              <p className="errorMsg">{errors.requirement_type.message}</p>
            )}
          </div>
        </div>

        <div className="mt-3 mb-3">
          <label htmlFor="remarks" className="form-label d-block w-100 mb-2" style={{ color: "#777", fontSize: "14px", fontWeight: 500 }}>
            Remarks <span className="errorMsg">*</span>
          </label>
          <TextField
            sx={{ width: "100%" }}
            size="small"
            name="remarks"
            placeholder="Enter remarks"
            {...register("remarks", {
              required: "Remarks field is required",
            })}
          />
          {errors.remarks && (
            <p className="errorMsg">{errors.remarks.message}</p>
          )}
        </div>

        <div className="mt-3 mb-3">
          <label htmlFor="amount" className="form-label d-block w-100 mb-2" style={{ color: "#777", fontSize: "14px", fontWeight: 500 }}>
            Amount <span className="errorMsg">*</span>
          </label>
          <TextField
            sx={{ width: "100%" }}
            size="small"
            name="amount"
            type="text"
            inputProps={{ inputMode: "numeric" }}
            placeholder="Enter amount"
            onKeyDown={(e) => {
              if (
                !/[0-9]/.test(e.key) &&
                !["Backspace", "Tab", "ArrowLeft", "ArrowRight", "Delete", "Enter"].includes(e.key)
              ) {
                e.preventDefault();
              }
            }}
            {...register("amount", {
              required: "Amount field is required",
              validate: validatePositiveAmount,
              pattern: {
                value: /^[0-9]+$/,
                message: "Only numbers are allowed",
              },
              onChange: (e) => {
                e.target.value = e.target.value.replace(/[^0-9]/g, "");
              },
            })}
          />
          {errors.amount && (
            <p className="errorMsg">{errors.amount.message}</p>
          )}
        </div>

        <div className="row mt-3 mb-3">
          

          <div className="col-md-6 mb-3">
            <label htmlFor="start_date" className="form-label d-block w-100 mb-2" style={{ color: "#777", fontSize: "14px", fontWeight: 500 }}>
              Start Date <span className="errorMsg">*</span>
            </label>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Controller
                name="start_date"
                control={control}
                rules={{
                  required: "Start Date is required",
                  validate: (val) => {
                    if (!val) return "Start Date is required";
                    const selected = dayjs(val);
                    if (!selected.isValid() || selected.year() < 1900) {
                      return "Year must be 1900 or later";
                    }
                    return true;
                  },
                }}
                render={({ field: { value, onChange } }) => (
                  <DatePicker
                    value={value ? dayjs(value) : null}
                    onChange={(newValue) => {
                      onChange(newValue ? dayjs(newValue).format("YYYY-MM-DD") : null);
                    }}
                    minDate={dayjs("1900-01-01")}
                    format="DD/MM/YYYY"
                    slotProps={{
                      popper: {
                        placement: "bottom-start",
                        disablePortal: false,
                        modifiers: [
                          {
                            name: "preventOverflow",
                            options: {
                              boundary: "window",
                            },
                          },
                        ],
                        sx: {
                          "& .MuiPaper-root": {
                            minHeight: "330px",
                          },
                        },
                      },
                      textField: {
                        fullWidth: true,
                        size: "small",
                      },
                    }}
                  />
                )}
              />
            </LocalizationProvider>
            {errors.start_date && (
              <p className="errorMsg">{errors.start_date.message}</p>
            )}
          </div>

          <div className="col-md-6 mb-3">
            <label htmlFor="end_date" className="form-label d-block w-100 mb-2" style={{ color: "#777", fontSize: "14px", fontWeight: 500 }}>
              End Date <span className="errorMsg">*</span>
            </label>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Controller
                name="end_date"
                control={control}
                rules={{
                  required: "End Date is required",
                  validate: (val, formValues) => {
                    if (!val) return "End Date is required";
                    const selected = dayjs(val);
                    if (!selected.isValid() || selected.year() < 1900) {
                      return "Year must be 1900 or later";
                    }
                    if (formValues.start_date && selected.isBefore(dayjs(formValues.start_date), "day")) {
                      return "End Date must be on or after Start Date";
                    }
                    return true;
                  },
                }}
                render={({ field: { value, onChange } }) => (
                  <DatePicker
                    value={value ? dayjs(value) : null}
                    onChange={(newValue) => {
                      onChange(newValue ? dayjs(newValue).format("YYYY-MM-DD") : null);
                    }}
                    minDate={dayjs("1900-01-01")}
                    format="DD/MM/YYYY"
                    slotProps={{
                      popper: {
                        placement: "bottom-start",
                        disablePortal: false,
                        modifiers: [
                          {
                            name: "preventOverflow",
                            options: {
                              boundary: "window",
                            },
                          },
                        ],
                        sx: {
                          "& .MuiPaper-root": {
                            minHeight: "330px",
                          },
                        },
                      },
                      textField: {
                        fullWidth: true,
                        size: "small",
                      },
                    }}
                  />
                )}
              />
            </LocalizationProvider>
            {errors.end_date && (
              <p className="errorMsg">{errors.end_date.message}</p>
            )}
          </div>

          <div className="col-md-6 mb-3">
            <label htmlFor="approved_date" className="form-label d-block w-100 mb-2" style={{ color: "#777", fontSize: "14px", fontWeight: 500 }}>
              Request Approved Date
            </label>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Controller
                name="approved_date"
                control={control}
                rules={{
                  validate: (val) => {
                    if (!val) return true;
                    const selected = dayjs(val);
                    if (!selected.isValid() || selected.year() < 1900) {
                      return "Year must be 1900 or later";
                    }
                    return true;
                  },
                }}
                render={({ field: { value, onChange } }) => (
                  <DatePicker
                    value={value ? dayjs(value) : null}
                    onChange={(newValue) => {
                      onChange(newValue ? dayjs(newValue).format("YYYY-MM-DD") : null);
                    }}
                    minDate={dayjs("1900-01-01")}
                    format="DD/MM/YYYY"
                    slotProps={{
                      popper: {
                        placement: "bottom-start",
                        disablePortal: false,
                        modifiers: [
                          {
                            name: "preventOverflow",
                            options: {
                              boundary: "window",
                            },
                          },
                        ],
                        sx: {
                          "& .MuiPaper-root": {
                            minHeight: "330px",
                          },
                        },
                      },
                      textField: {
                        fullWidth: true,
                        size: "small",
                      },
                    }}
                  />
                )}
              />
            </LocalizationProvider>
            {errors.approved_date && (
              <p className="errorMsg">{errors.approved_date.message}</p>
            )}
          </div>
        </div>
      </div>

      <div className="d-flex p-3 align-items-center position-absolute bottom-0 w-100 bg-white gap-3">
        <button
          type="submit"
          className="add_btn"
          disabled={loading}
        >
          {loading ? (initialData ? "Updating..." : "Adding...") : (initialData ? "Update" : "Add")}
        </button>
        <button
          className="cancel_btn"
          type="button"
          onClick={oncancel}
          disabled={loading}
        >
          Cancel
        </button>
      </div>
    </form>
  );
};

export const AdditionalScopeTable = ({ data, onDelete, onEdit, isLoading }) => {
  const { isDarkMode } = useTheme();
  const hasData = data && data.length > 0;
  const [deleteItem, setDeleteItem] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const parseAmt = (val) => typeof val === "number" ? val : (parseFloat(String(val || 0).replace(/,/g, "")) || 0);

  const formatScopeDate = (dateStr) => {
    if (!dateStr || dateStr === "No Data" || dateStr === "-") return "-";
    const d = dayjs(dateStr);
    if (!d.isValid() || d.year() < 1900) return "-";
    return d.format("DD/MM/YYYY");
  };

  const totalScopeAmount = hasData
    ? data.reduce((acc, item) => acc + parseAmt(item.amount), 0)
    : 0;

  const handleConfirmDelete = async () => {
    if (deleteItem !== null) {
      setDeleteLoading(true);
      try {
        await onDelete(deleteItem.scope_id);
        setDeleteItem(null);
      } 
      catch (err) {
        // error handled in parent
      } 
      finally {
        setDeleteLoading(false);
      }
    }
  };

  return (
    <>
      <Box
        sx={{
          overflowX: "auto",
          border: isDarkMode ? "1px solid #333" : "1px solid #e0e0e0",
          width: "100%",
          marginBottom: 2,
        }}
      >
        <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="center" style={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }}>S.No</TableCell>
                <TableCell align="left" style={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }}>Request Type</TableCell>
                <TableCell align="left" style={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }}>Remarks</TableCell>
                <TableCell align="right" style={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }}>Amount</TableCell>
                <TableCell align="left" style={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }}>Start Date</TableCell>
                <TableCell align="left" style={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }}>End Date</TableCell>
                <TableCell align="left" style={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }}>Approved Date</TableCell>
                <TableCell align="left" style={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }}>Created At</TableCell>
                <TableCell align="left" style={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }}>Updated At</TableCell>
                <TableCell align="center" style={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }}>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {isLoading ? (
                <TableRow>
                  <TableCell colSpan={10} align="center">
                    <Typography variant="subtitle1" color="textSecondary" sx={{ py: 2 }}>
                      Loading...
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : !hasData ? (
                <TableRow>
                  <TableCell colSpan={10} align="center">
                    <Typography variant="subtitle1" color="textSecondary" sx={{ py: 2 }}>
                      No Additional Scope / Change Request Found
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : (
                <>
                  {data.map((additionalScope, index) => (
                    <TableRow key={additionalScope.scope_id || index}>
                      <TableCell align="center">{index + 1}</TableCell>
                      <TableCell align="left">{additionalScope.type}</TableCell>
                      <TableCell align="left">{additionalScope.remarks}</TableCell>
                      <TableCell align="right">
                        {formatINR(parseAmt(additionalScope.amount))}
                      </TableCell>
                      <TableCell align="left">{formatScopeDate(additionalScope.start_date)}</TableCell>
                      <TableCell align="left">{formatScopeDate(additionalScope.end_date)}</TableCell>
                      <TableCell align="left">{formatScopeDate(additionalScope.approved_date)}</TableCell>
                      <TableCell align="left">{formatScopeDate(additionalScope.created_at)}</TableCell>
                      <TableCell align="left">{formatScopeDate(additionalScope.updated_at)}</TableCell>
                      <TableCell align="center">
                        <div className="d-flex gap-2 justify-content-center">
                          <Button
                            variant="outlined"
                            color="primary"
                            size="small"
                            onClick={() => onEdit(additionalScope)}
                            sx={{ textTransform: "capitalize" }}
                          >
                            Edit
                          </Button>
                          <Button
                            variant="outlined"
                            color="error"
                            size="small"
                            onClick={() => setDeleteItem(additionalScope)}
                            sx={{ textTransform: "capitalize" }}
                          >
                            Delete
                          </Button>
                        </div>
                      </TableCell>
                    </TableRow>
                  ))}

                  {/* Total Row */}
                  <TableRow
                    sx={{
                      position: "sticky",
                      bottom: 0,
                      backgroundColor: "var(--cell-bg-color)",
                      zIndex: 1,
                    }}
                  >
                    <TableCell colSpan={3} align="right">
                      <Typography fontWeight="bold" sx={{ mr: "7px" }}>Total Amount</Typography>
                    </TableCell>
                    <TableCell align="right">
                      <Typography fontWeight="bold">
                        {formatINR(totalScopeAmount)}
                      </Typography>
                    </TableCell>
                    <TableCell colSpan={6}></TableCell>
                  </TableRow>
                </>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      {/* MUI Delete Confirmation Dialog */}
      <Dialog
        open={deleteItem !== null}
        onClose={() => setDeleteItem(null)}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: {
            bgcolor: isDarkMode ? "#1e1e1e" : "#fff",
            color: isDarkMode ? "#f2f1f1" : "inherit",
            border: isDarkMode ? "1px solid #333" : "none",
            borderRadius: "8px",
          },
        }}
      >
        <DialogTitle sx={{ fontWeight: 600, fontSize: "16px", color: isDarkMode ? "#f2f1f1" : "inherit" }}>
          Confirm Delete
        </DialogTitle>
        <DialogContent sx={{ pt: 1, pb: 1.5 }}>
          <Typography sx={{ fontSize: "14px", color: isDarkMode ? "#cbd5e1" : "#555", mb: 1.5 }}>
            Are you sure you want to delete this Additional Scope item?
          </Typography>
          {deleteItem && (
            <Box
              sx={{
                p: 2,
                bgcolor: isDarkMode ? "#121212 !important" : "#f8fafc",
                borderRadius: "6px",
                border: isDarkMode ? "1px solid #333" : "1px solid #e2e8f0",
                display: "grid",
                gridTemplateColumns: "115px 1fr",
                rowGap: "8px",
                columnGap: "12px",
                alignItems: "center",
              }}
            >
              <Typography sx={{ fontSize: "12.5px", fontWeight: 500, color: isDarkMode ? "#94a3b8 !important" : "#64748b" }}>
                Request Type:
              </Typography>
              <Typography sx={{ fontSize: "13px", fontWeight: 600, color: isDarkMode ? "#f1f5f9 !important" : "#1e293b" }}>
                {deleteItem.type || "-"}
              </Typography>

              <Typography sx={{ fontSize: "12.5px", fontWeight: 500, color: isDarkMode ? "#94a3b8 !important" : "#64748b" }}>
                Remarks:
              </Typography>
              <Typography sx={{ fontSize: "12.5px", color: isDarkMode ? "#cbd5e1 !important" : "#475569" }}>
                {deleteItem.remarks || "-"}
              </Typography>

              <Typography sx={{ fontSize: "12.5px", fontWeight: 500, color: isDarkMode ? "#94a3b8 !important" : "#64748b" }}>
                Amount:
              </Typography>
              <Typography sx={{ fontSize: "13px", fontWeight: 600, color: isDarkMode ? "#34d399 !important" : "#059669" }}>
                {formatINR(parseAmt(deleteItem.amount))}
              </Typography>

              <Typography sx={{ fontSize: "12.5px", fontWeight: 500, color: isDarkMode ? "#94a3b8 !important" : "#64748b" }}>
                Approved Date:
              </Typography>
              <Typography sx={{ fontSize: "12.5px", color: isDarkMode ? "#cbd5e1 !important" : "#475569" }}>
                {deleteItem.approved_date ? dayjs(deleteItem.approved_date).format("DD/MM/YYYY") : "-"}
              </Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2, pt: 1 }}>
          <Button
            onClick={() => setDeleteItem(null)}
            variant="outlined"
            color="inherit"
            size="small"
            sx={{
              textTransform: "capitalize",
              color: isDarkMode ? "#f2f1f1" : "inherit",
              borderColor: isDarkMode ? "var(--border-color, #444)" : undefined,
              "&:hover": {
                borderColor: isDarkMode ? "#666" : undefined,
                backgroundColor: isDarkMode ? "rgba(255, 255, 255, 0.05)" : undefined,
              },
            }}
            disabled={deleteLoading}
          >
            Cancel
          </Button>
          <Button
            onClick={handleConfirmDelete}
            variant="contained"
            color="error"
            size="small"
            sx={{ textTransform: "capitalize" }}
            disabled={deleteLoading}
          >
            {deleteLoading ? "Deleting..." : "Delete"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

const BudgetTab = () => {
  const { isDarkMode } = useTheme();
  const {
    handleSubmit,
    control,
    register,
    watch,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      project_span: "all",
      // from_date: dayjs().format("YYYY-MM-DD"),
      // to_date: dayjs().format("YYYY-MM-DD"),
    },
  });
  const [budgetOpen, setBudgetOpen] = useState(true);
  const [openSummaryTable, setOpenSummaryTable] = useState(true);
  const [openPaymentReceivedTable, setOpenPaymentReceivedTable] =
    useState(true);
  const [filteredData, setFilteredData] = useState([]);
  const [initialGroupedData, setInitialGroupedData] = useState(null);
  const [budgetRefreshKey, setBudgetRefreshKey] = useState(0);
  const handleBudgetRefresh = () => setBudgetRefreshKey((prev) => prev + 1);
  const [showAddpayment, setShowAddPayment] = useState(false);
  const [showAddExpense, setShowAddExpense] = useState(false);
  const [showAddScope, setShowAddScope] = useState(false);
  const [editingScopeItem, setEditingScopeItem] = useState(null);
  const [openAdditionalScopeTable, setOpenAdditionalScopeTable] = useState(true);
  const [showcretaedUserName, setShowcretaedUserName] = useState([]);
  const [openFixedExpenseTable, setOpenFixedExpenseTable] = useState(true);
  const project_id = localStorage.getItem("project_id");
  const reduxProjectName = useSelector((state) => state.selectOptions?.projectName);

  const {
    data: budgetOverview,
    isLoading: budgetOverviewLoading,
    refetch: refetchBudgetOverview,
  } = useFetchBudgetOverviewQuery(project_id, {
    skip: !project_id,
    // Always read again when the tab is opened (see EmployeeBudgetView).
    refetchOnMountOrArgChange: true,
  });
  // Re-reads the Budget status bar after money was added (nothing to refresh without a project).
  const refreshBudgetOverview = () => {
    if (project_id) refetchBudgetOverview();
  };
  const [projectDetails, setProjectDetails] = useState(null);
  const [isExportingPDF, setIsExportingPDF] = useState(false);

  const { data: projectDetailsData } = useFetchViewProjectsByIdQuery(project_id, {
    skip: !project_id,
  });
  const projectInfo = projectDetailsData?.data;
  // Whether the budget % gauge applies to this project (Fixed Cost only).
  const budgetTracking = useBudgetTracking(project_id, budgetOverview, budgetOverviewLoading);

  useEffect(() => {
    if (project_id) {
      fetchEntityById("projects", project_id)
        .then((res) => {
          if (res?.data) {
            setProjectDetails(res.data);
          }
        })
        .catch(() => {});
    }
  }, [project_id]);

  const displayProjectTitle =
    projectDetails?.title ||
    projectInfo?.title ||
    projectDetailsData?.title ||
    reduxProjectName ||
    "Project Budget Report";

  const displayProjectStatus =
    projectDetails?.current_status_name ||
    projectDetails?.status_name ||
    projectDetails?.status ||
    projectInfo?.current_status_name ||
    projectInfo?.status_name ||
    "";

  // Real API: GET all additional scopes
  const {
    data: additionalScopes = [],
    isLoading: additionalScopesLoading,
    refetch: refetchAdditionalScopes,
  } = useFetchBudgetAdditionalScopesQuery(project_id, {
    refetchOnMountOrArgChange: true,
  });

  const [deleteAdditionalScope] = useDeleteAdditionalScopeMutation();

  const sortedAdditionalScopes = useMemo(
    () => [...(additionalScopes || [])].sort((a, b) => (a.scope_id || 0) - (b.scope_id || 0)),
    [additionalScopes]
  );
  const [loading, setLoading] = useState(false);
  const [selectedOption, setSelectedOption] = useState("all");
  const [selectedLabel, setSelectedLabel] = useState("All");
  const [loadingOptions, setLoadingOptions] = useState(false);
  const [isDateApplied, setIsDateApplied] = useState(false);
  const [showClearFilter, setShowClearFilter] = useState(false);
  const [customDateEnabled, setCustomDateEnabled] = useState(false);
  const [customFromDate, setCustomFromDate] = useState("");
  const [customToDate, setCustomToDate] = useState("");
  const [dateRange, setDateRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  const [selectedMonth, setSelectedMonth] = useState(dayjs());
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [showMonthPicker, setShowMonthPicker] = useState(false);
  const [dummyData, setDummyData] = useState("Option 1");
   
  const budgetContainerRef = useRef(null);

  const canvasToPDFBlob = (canvas) => {
    // Standard A4 dimensions in PDF points (72 points per inch)
    const pageWidth = 595.28;  // 210mm
    const pageHeight = 841.89; // 297mm
    const margin = 20; // 20pt margin

    const renderWidth = pageWidth - margin * 2; // 555.28pt
    const pageContentHeight = pageHeight - margin * 2; // 801.89pt

    const imgWidth = canvas.width;
    const imgHeight = canvas.height;

    const totalRenderHeight = (imgHeight * renderWidth) / imgWidth;
    const totalPages = Math.max(1, Math.ceil(totalRenderHeight / pageContentHeight));

    const scaleFactor = imgWidth / renderWidth;
    const sliceSourceHeight = pageContentHeight * scaleFactor;

    const pdf = new jsPDF({
      orientation: "portrait",
      unit: "pt",
      format: "a4",
      compress: true,
    });

    const createdDateText = `Created Date : ${dayjs().format("DD/MM/YYYY - hh:mm A")}`;

    for (let p = 0; p < totalPages; p++) {
      if (p > 0) {
        pdf.addPage("a4", "portrait");
      }

      const sourceY = p * sliceSourceHeight;
      const sourceH = Math.min(sliceSourceHeight, imgHeight - sourceY);
      const sliceRenderHeight = (sourceH * renderWidth) / imgWidth;

      // Crop slice on a sub-canvas
      const pageCanvas = document.createElement("canvas");
      pageCanvas.width = imgWidth;
      pageCanvas.height = Math.max(1, sourceH);
      const ctx = pageCanvas.getContext("2d");
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, pageCanvas.width, pageCanvas.height);
      ctx.drawImage(
        canvas,
        0, sourceY, imgWidth, sourceH,
        0, 0, imgWidth, sourceH
      );

      const jpegUrl = pageCanvas.toDataURL("image/jpeg", 0.95);
      pdf.addImage(jpegUrl, "JPEG", margin, margin, renderWidth, sliceRenderHeight);

      // Render Created Date & time in a single horizontal line at the bottom right corner ONLY on the last page
      if (p === totalPages - 1) {
        pdf.setFontSize(8);
        pdf.setTextColor(110, 110, 110);
        pdf.text(createdDateText, pageWidth - margin, pageHeight - 8, { align: "right" });
      }
    }

    return pdf.output("blob");
  };

  const handleExportPDF = async () => {
    Swal.close();

    const result = await Swal.fire({
      title: "Export PDF Confirmation",  
      text: "Are you sure you want to export the Budget as PDF?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Export PDF",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#04a189",
      cancelButtonColor: "#d33",
      allowOutsideClick: true,
      allowEscapeKey: true,
      backdrop: true,
      background: isDarkMode ? "#1e1e1e" : "#ffffff",
      color: isDarkMode ? "#ffffff" : "#000000",
    });

    if (!result.isConfirmed) return;

    if (!budgetContainerRef.current) {
      toast.error("Budget content not found");
      return;
    }

    const toastId = toast.loading("Generating Budget PDF...");

    const prevBudgetOpen = budgetOpen;
    const prevFixedOpen = openFixedExpenseTable;
    const prevPaymentOpen = openPaymentReceivedTable;
    const prevScopeOpen = openAdditionalScopeTable;
    const prevSummaryOpen = openSummaryTable;

    try {
      // Temporarily expand all budget sections to include all tables in PDF
      setBudgetOpen(true);
      setOpenFixedExpenseTable(true);
      setOpenPaymentReceivedTable(true);
      setOpenAdditionalScopeTable(true);
      setOpenSummaryTable(true);

      // Wait 800ms for all Collapse animations (timeout=700ms) to fully expand
      await new Promise((res) => setTimeout(res, 800));

      const canvas = await html2canvas(budgetContainerRef.current, {
        scale: 2,
        backgroundColor: "#ffffff",
        useCORS: true,
        logging: false,
        windowWidth: 1400,
        ignoreElements: (el) => el.classList.contains("budget_dropdown_btn"),
        onclone: (clonedDoc) => {
          const pdfHeader = clonedDoc.getElementById("pdf-header-export-only");
          if (pdfHeader) {
            pdfHeader.style.display = "flex";
          }

          // Ensure all tables, collapses, and containers expand fully so no rows, amounts, or columns are clipped
          const pdfContainer = clonedDoc.querySelector(".budget-export-pdf-container");
          if (pdfContainer) {
            // Fix: Ensure all table title headers (Resource Expenses, Fixed Expenses, etc.) are visible in dark mode PDF with 6px bottom margin
            const sectionTitles = pdfContainer.querySelectorAll(".budget-pdf-section-title");
            sectionTitles.forEach((el) => {
              el.style.setProperty("color", "#111827", "important");
              el.style.setProperty("font-weight", "bold", "important");
              el.style.setProperty("margin-bottom", "6px", "important");
              el.style.setProperty("display", "inline-block", "important");
            });

            const titleContainers = pdfContainer.querySelectorAll(".budget-pdf-title-container");
            titleContainers.forEach((el) => {
              el.style.setProperty("margin-bottom", "6px", "important");
            });

            // 1. Force all Collapse wrappers to be fully visible and expanded
            const collapseElements = pdfContainer.querySelectorAll(".MuiCollapse-root, .MuiCollapse-wrapper, .MuiCollapse-wrapperInner");
            collapseElements.forEach((el) => {
              el.style.setProperty("height", "auto", "important");
              el.style.setProperty("max-height", "none", "important");
              el.style.setProperty("opacity", "1", "important");
              el.style.setProperty("visibility", "visible", "important");
            });

            // 2. Remove all max-height, overflow, and right margin restrictions on all boxes and table containers
            const allElements = pdfContainer.querySelectorAll("*");
            allElements.forEach((el) => {
              el.style.setProperty("max-height", "none", "important");
              el.style.setProperty("overflow", "visible", "important");
              el.style.setProperty("overflow-x", "visible", "important");
              el.style.setProperty("overflow-y", "visible", "important");
            });

            // 3. Reset right margins on summary boxes (e.g. marginRight: 150px)
            const allBoxes = pdfContainer.querySelectorAll(".MuiBox-root");
            allBoxes.forEach((el) => {
              el.style.setProperty("margin-right", "0px", "important");
            });

            // 4. Reset sticky headers/footers to static so they render at the exact natural start and end of each table
            const stickyElements = pdfContainer.querySelectorAll("tr, thead, th, td");
            stickyElements.forEach((el) => {
              el.style.setProperty("position", "static", "important");
            });

            // 5. Ensure tables occupy full width
            const tables = pdfContainer.querySelectorAll("table");
            tables.forEach((el) => {
              el.style.setProperty("width", "100%", "important");
              el.style.setProperty("min-width", "100%", "important");
            });
          }
        },
      });

      const pdfBlob = canvasToPDFBlob(canvas);
      const safeProjectName = (displayProjectTitle && displayProjectTitle !== "Project Budget Report" ? displayProjectTitle : "Project").replace(/[^a-zA-Z0-9_-]/g, "_");
      saveAs(pdfBlob, `${safeProjectName}_Budget_Report.pdf`);

      toast.update(toastId, {
        render: "Budget PDF downloaded successfully!",
        type: "success",
        isLoading: false,
        autoClose: 2000,
      });
    } catch (err) {
      console.error("PDF export error:", err);
      toast.update(toastId, {
        render: "Failed to download PDF",
        type: "error",
        isLoading: false,
        autoClose: 2000,
      });
    } finally {
      // Restore collapse states
      setBudgetOpen(prevBudgetOpen);
      setOpenFixedExpenseTable(prevFixedOpen);
      setOpenPaymentReceivedTable(prevPaymentOpen);
      setOpenAdditionalScopeTable(prevScopeOpen);
      setOpenSummaryTable(prevSummaryOpen);
    }
  };

  const handleSelectChange = (event) => {
    const selectedValue = event.target.value;

    if (selectedValue === "week") {
      setShowDatePicker(true); // Show week calendar
      setShowMonthPicker(false); // Hide month calendar
      setSelectedOption("week"); // Set project span to "week"
    } else if (selectedValue === "month") {
      setShowMonthPicker(true);
      setShowDatePicker(false);
      setSelectedOption("month");
    } else {
      setShowDatePicker(false);
      setShowMonthPicker(false);
      setSelectedOption("all");
      setSelectedLabel("All");

      // Call API with 'all' and no date range (or set any default range for "all")
      handleApiCall({
        project_span: "all", // Set project span to "all"
        from_date: null, // or set some default value like "start of year"
        to_date: null, // or set some default value like "end of year"
      });
    }
  };

  const handleDummySelectChange = (event) => {
    setDummyData(event.target.value);
  };

  const handleRangeChange = (ranges) => {
    setDateRange([ranges.selection]);
  };
  // const handleApply = () => {
  //   const startOfWeek = dayjs(dateRange[0].startDate)
  //     .startOf("week")
  //     .format("YYYY-MM-DD");
  //   const endOfWeek = dayjs(dateRange[0].endDate)
  //     .endOf("week")
  //     .format("YYYY-MM-DD");
  //   setSelectedLabel(`${startOfWeek} – ${endOfWeek}`);
  //   //console.log("Selected Week: ", startOfWeek, endOfWeek);

  //   // Call the API with project_span set to "week"
  //   handleApiCall({
  //     project_span: "week", // Set project span to "week"
  //     from_date: startOfWeek,
  //     to_date: endOfWeek,
  //   });

  //   setShowDatePicker(false); // Close the week picker dialog
  // };
  
  const handleApply = () => {
    const startOfWeek = dayjs(dateRange[0].startDate)
      .startOf("week")
      .format("DD-MM-YYYY"); // updated format
    const endOfWeek = dayjs(dateRange[0].endDate)
      .endOf("week")
      .format("DD-MM-YYYY"); // updated format

    setSelectedLabel(`${startOfWeek} – ${endOfWeek}`);
    setIsDateApplied(true);
    handleApiCall({
      project_span: "week",
      from_date: dayjs(dateRange[0].startDate)
        .startOf("week")
        .format("YYYY-MM-DD"), // API format
      to_date: dayjs(dateRange[0].endDate).endOf("week").format("YYYY-MM-DD"), // API format
    });

    setShowDatePicker(false);
  };

  const handleCancel = () => {
    setShowDatePicker(false);
  };

  const handleMonthChange = (newValue) => {
    setSelectedMonth(newValue);
  };
  // const handleMonthApply = () => {
  //   const startOfMonth = selectedMonth.startOf("month").format("YYYY-MM-DD");
  //   const endOfMonth = selectedMonth.endOf("month").format("YYYY-MM-DD");

  //   //console.log("Selected Month: ", startOfMonth, endOfMonth);
  //   setSelectedLabel(`${startOfMonth} – ${endOfMonth}`);
  //   // Call the API with project_span set to "month"
  //   handleApiCall({
  //     project_span: "month", // Set project span to "month"
  //     from_date: startOfMonth,
  //     to_date: endOfMonth,
  //   });

  //   setShowMonthPicker(false); // Close the month picker dialog
  // };
  const handleMonthApply = () => {
    const startOfMonth = selectedMonth.startOf("month").format("DD-MM-YYYY"); // updated format
    const endOfMonth = selectedMonth.endOf("month").format("DD-MM-YYYY"); // updated format

    setSelectedLabel(`${startOfMonth} – ${endOfMonth}`);

    handleApiCall({
      project_span: "month",
      from_date: selectedMonth.startOf("month").format("YYYY-MM-DD"), // API format
      to_date: selectedMonth.endOf("month").format("YYYY-MM-DD"), // API format
    });
    setIsDateApplied(true);
    setShowMonthPicker(false);
  };

  const handleMonthCancel = () => {
    setShowMonthPicker(false);
  };

  const handleApiCall = async ({ project_span, from_date, to_date, showLoader = true }) => {
    const users = watch("users");
    //console.log("user_changed : ", users);
    if (showLoader) {
      setLoading(true);
    }
    const projectSpan = watch("project_span");
    const requestedData = {
      project_span: project_span || projectSpan, // Week, Month, or All
      from_date: from_date,
      to_date: to_date,
      users,
    };

    try {
      const response = await getAllData(
        `projects/budget/filter/${project_id}`,
        requestedData
      );
      setFilteredData(response); // Update the filtered data
      if (!from_date && !to_date && (requestedData.project_span === "all" || !requestedData.project_span)) {
        if (response?.data?.grouped_data) {
          setInitialGroupedData(response.data.grouped_data);
        }
      }

      if (response?.message) {
        toast.success(response.message);
      }
    } catch (error) {
      const errorMsg = error.message;
      setFilteredData([]);
      toast.error(errorMsg, { toastId: errorMsg || "custom-date-error" });
    } finally {
      if (showLoader) {
        setLoading(false);
      }
    }
  };

  const fetchCreatedByUsers = async () => {
    setLoadingOptions(true); // Start loader
    try {
      const response = await fetchEntityById("usersInProjects", project_id);
      //console.log("getAllUsersDetails names :", response);
      setShowcretaedUserName(response.data);
    } catch (err) {
      // console.error("Failed to fetch createdBy users:", err);
      toast.error("Failed to fetch createdBy users");
    } finally {
      setLoadingOptions(false); // Stop loader
    }
  };

  useEffect(() => {
    handleApiCall({ from_date: null, to_date: null });
    fetchCreatedByUsers();
  }, 
  
  
  [projectSpan]);

  // useEffect(() => {
  //   const projectSpan = watch("project_span") || "all";
  //   const users = watch("users") || [];

  //   // Skip API call for week/month until user clicks "Apply"
  //   if (projectSpan === "week" || projectSpan === "month") {
  //     return;
  //   }

  //   handleApiCall({
  //     project_span: projectSpan,
  //     from_date: null,
  //     to_date: null,
  //     users,
  //   });
  // }, [watch("project_span"), watch("users")]);


  
  useEffect(() => {
    const projectSpan = watch("project_span") || "all";
    const users = watch("users") || [];

    let from_date = null;
    let to_date = null;

    if (customDateEnabled) {
      if (customFromDate && customToDate) {
        from_date = customFromDate;
        to_date = customToDate;
      } else {
        return;
      }
    } else if (projectSpan === "week") {
      if (!isDateApplied) return;
      from_date = dayjs(dateRange[0].startDate)
        .startOf("week")
        .format("YYYY-MM-DD");
      to_date = dayjs(dateRange[0].endDate).endOf("week").format("YYYY-MM-DD");
    } else if (projectSpan === "month") {
      if (!isDateApplied) return;
      from_date = selectedMonth.startOf("month").format("YYYY-MM-DD");
      to_date = selectedMonth.endOf("month").format("YYYY-MM-DD");
    }

    // For 'all', or after date is applied for week/month
    handleApiCall({
      project_span: customDateEnabled ? "custom" : projectSpan,
      from_date,
      to_date,
      users,
    });
  }, [watch("users"), customDateEnabled, customFromDate, customToDate]);

  const onsubmit = (data) => {
    //console.log("Form submitted:", data);
  };
  const hadleShowExpense = () => {
    setShowAddExpense(false);
  };
  useEffect(() => {
    setIsDateApplied(false);
  }, [watch("project_span")]);
  useEffect(() => {
    const users = watch("users") || [];
    const projectSpan = watch("project_span");

    const isCustomDateSelected = customDateEnabled && (customFromDate || customToDate);

    if ((projectSpan !== "all" && isDateApplied) || isCustomDateSelected) {
      setShowClearFilter(true);
    } else {
      setShowClearFilter(false);
    }
  }, [watch("project_span"), isDateApplied, customDateEnabled, customFromDate, customToDate]);
  const handleClearFilter = () => {
    reset({ project_span: "all", users: [] });
    setSelectedLabel("All");
    setIsDateApplied(false);
    setDateRange([
      { startDate: new Date(), endDate: new Date(), key: "selection" },
    ]);
    setCustomFromDate("");
    setCustomToDate("");
    handleApiCall({
      project_span: "all",
      from_date: null,
      to_date: null,
      users: [],
    });
  };

  return (
    <div style={{ padding: "9px 16px" }} className="bg-white">
      {/* ad payment */}
      <Offcanvas placement="end" show={showAddpayment} style={{ width: "50%" }}>
        <OffcanvasBody>
          <AddPaymentComponent
            onClose={() => setShowAddPayment(false)} // Close the Offcanvas
            onapply={() => {
              //console.log("Save triggered");
              // setShowAddPayment(false); // Close on apply
            }}
            onRefetch={refreshBudgetOverview}
            oncancel={() => {
              //console.log("Cancel triggered");
              setShowAddPayment(false); // Close on cancel
            }}
          />
        </OffcanvasBody>
      </Offcanvas>
      {/* add expese */}
      <Offcanvas placement="end" show={showAddExpense} style={{ width: "50%" }}>
        <OffcanvasBody>
          <AddExpenseComponent
            oncancel={() => setShowAddExpense(false)}
            onApply={hadleShowExpense}
            onclose={() => setShowAddExpense(false)}
            onRefetch={() => {
              handleBudgetRefresh();
              refreshBudgetOverview();
            }}
          />
        </OffcanvasBody>
      </Offcanvas>
      {/* add scope */}
      <Offcanvas placement="end" show={showAddScope} style={{ width: "50%" }}>
        <OffcanvasBody>
          <AddScopeComponent
            initialData={editingScopeItem}
            oncancel={() => {
              setShowAddScope(false);
              setEditingScopeItem(null);
            }}
            onapply={() => {}}
            onRefetch={() => {
              refetchAdditionalScopes();
              setShowAddScope(false);
              setEditingScopeItem(null);
            }}
          />
        </OffcanvasBody>
      </Offcanvas>

      <form action="" onSubmit={handleSubmit(onsubmit)}>
        <Box
          className="row align-items-center"
          sx={{
            border: isDarkMode ? "1px solid #333" : "1px solid #e0e0e0",
            borderRadius: "6px",
            padding: "12px 16px",
            marginBottom: "9px",
            backgroundColor: isDarkMode ? "transparent" : "#fff",
            mx: 0,
          }}
        >
          <div className="d-flex flex-column gap-3 w-100">
            <div className="d-flex gap-3 align-items-center w-100 flex-wrap flex-md-nowrap">
              {/* Budget Select Dropdown */}
              <div className="div  flex-grow-1 ">
                <Controller
                  name="users"
                  control={control}
                  rules={{ required: "Users  is required" }}
                  render={({ field: { onChange, value } }) => (
                    <Autocomplete
                      multiple
                      id="users"
                      disabled={customDateEnabled}
                      options={showcretaedUserName}
                      disableCloseOnSelect
                      loading={loadingOptions}
                      getOptionLabel={(option) => option.name}
                      value={
                        value?.map((id) =>
                          showcretaedUserName.find((user) => user.user_id === id)
                        ).filter(Boolean) || []
                      }
                      onChange={(event, newValue) => {
                        const selectedIds = newValue.map((user) => user.user_id);
                        onChange(selectedIds); // Update form state with user IDs
                      }}
                      renderOption={(props, option, { selected }) => (
                        <li
                          {...props}
                          className="d-flex flex-column flex-md-row mb-2"
                        >
                        <Checkbox style={{ marginRight: 8 }} checked={selected} />
                          <Avatar style={{ marginRight: 8 }}>
                            {option.avatar || option.name[0]}
                          </Avatar>
                          <div className="d-flex flex-column">
                            <strong>{option.name}</strong>
                            <small>{option.role}</small>
                          </div>
                        </li>
                      )}
                      renderInput={(params) => (
                        <TextField {...params} placeholder="Enter Users Name" />
                      )}
                      ListboxProps={{
                        style: {
                          display: "grid",
                          gridTemplateColumns: "1fr 1fr", // Two columns
                          gap: "7px",
                          paddingLeft: "0", // Removes default padding
                        },
                      }}
                      sx={{
                        backgroundColor: customDateEnabled ? "#f5f5f5" : "transparent",
                        borderRadius: "4px",
                      }}
                    />
                  )}
                />
              </div>
              {showClearFilter && !customDateEnabled && (
                <button
                  className="addmore_btn"
                  disabled={loading}
                  onClick={handleClearFilter}
                >
                  Clear Filter
                </button>
              )}

              {/* Project Span Select Dropdown */}
              <div style={{ width: "300px" }}>
                <div className="d-flex justify-content-center mb-1">
                  <FormControl style={{ width: "300px" }} fullWidth disabled={customDateEnabled}>
                    <Controller
                      name="project_span"
                      control={control}
                      render={({ field }) => (
                        <>
                          <Select
                            value={selectedOption}
                            onChange={handleSelectChange}
                            displayEmpty
                            disabled={customDateEnabled}
                            className="w-100"
                            renderValue={() => selectedLabel}
                            sx={{
                              backgroundColor: customDateEnabled ? "#f5f5f5" : "transparent",
                            }}
                          >
                            <MenuItem
                              value="week"
                              onClick={() => {
                                setSelectedOption("week");
                                setShowDatePicker(true);
                                setValue("project_span", "week");
                              }}
                            >
                              Week
                            </MenuItem>
                            <MenuItem
                              value="month"
                              onClick={() => {
                                setSelectedOption("month");
                                setShowMonthPicker(true);
                                setValue("project_span", "month");
                              }}
                            >
                              Month
                            </MenuItem>
                            <MenuItem
                              value="all"
                              onClick={() => {
                                setSelectedOption("all");
                                setShowDatePicker(false);
                                setShowMonthPicker(false);
                                setSelectedLabel("All");
                                setValue("project_span", "all");
                                handleApiCall({
                                  project_span: "all",
                                  from_date: null,
                                  to_date: null,
                                });
                              }}
                            >
                              All
                            </MenuItem>
                          </Select>
                        </>
                      )}
                    />
                  </FormControl>
                </div>

                {/* Week Picker Popup */}
                <Dialog
                  open={showDatePicker}
                  onClose={handleCancel}
                  sx={{ width: "90%" }}
                >
                  <DialogTitle>Select Week</DialogTitle>
                  <DialogContent className="rdrDateRangePickerWrapper">
                    <DateRangePicker
                      ranges={dateRange}
                      onChange={handleRangeChange}
                      showSelectionPreview={true}
                      moveRangeOnFirstSelection={false}
                      months={1}
                      direction="horizontal"
                    />
                  </DialogContent>
                  <DialogActions>
                    <button className=" add_btn" onClick={handleApply}>
                      Apply
                    </button>
                    <button className=" cancel_btn" onClick={handleCancel}>
                      Cancel
                    </button>
                  </DialogActions>
                </Dialog>

                {/* Month Picker Popup */}
                <Dialog
                  open={showMonthPicker}
                  onClose={handleMonthCancel}
                  sx={{ width: "90%" }}
                >
                  <DialogTitle>Select Month</DialogTitle>
                  <DialogContent>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <StaticDatePicker
                        views={["year", "month"]}
                        value={selectedMonth}
                        onChange={handleMonthChange}
                        disableOpenPicker={true}
                        displayStaticWrapperAs="desktop" // This removes the extra header
                        slotProps={{
                          actionBar: { actions: [] }, // Removes OK & Cancel buttons
                        }}
                      />
                    </LocalizationProvider>
                  </DialogContent>
                  <DialogActions>
                    <button className=" add_btn" onClick={handleMonthApply}>
                      Apply
                    </button>
                    <button className=" cancel_btn" onClick={handleMonthCancel}>
                      Cancel
                    </button>
                  </DialogActions>
                </Dialog>
              </div>

              {/* Buttons */}
              <div className="">
                <button
                  className="show-btn text-capitalize border-0"
                  onClick={() => setShowAddPayment((open) => !open)}
                >
                  add payment
                </button>
              </div>
              <div>
                <button
                  className="show-btn text-capitalize border-0"
                  onClick={() => setShowAddExpense((open) => !open)}
                >
                  add expense
                </button>
              </div>
            </div>

            {/* Custom Date Row */}
            <div className="d-flex gap-3 align-items-center w-100 flex-wrap mt-1 justify-content-between">
              <div className="d-flex align-items-center gap-3 flex-wrap">
                <div className="d-flex align-items-center gap-2">
                  <FormControlLabel
                    control={
                      <Switch
                        checked={customDateEnabled}
                        onChange={(e) => {
                          const enabled = e.target.checked;
                          setCustomDateEnabled(enabled);
                          if (enabled) {
                            // When entering custom date, reset selected users so custom dates act independently
                            setValue("users", []);
                          } else {
                            const hadCustomFilter = customFromDate && customToDate;
                            setCustomFromDate("");
                            setCustomToDate("");
                            if (hadCustomFilter) {
                              handleApiCall({
                                project_span: watch("project_span") || "all",
                                from_date: null,
                                to_date: null,
                                users: [],
                                showLoader: false,
                              });
                            }
                          }
                        }}
                        sx={{
                          "& .MuiSwitch-track": {
                            backgroundColor: "transparent !important",
                            border: "1.5px solid #ccc",
                            opacity: "1 !important",
                          },
                          "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                            backgroundColor: "transparent !important",
                            border: "1.5px solid #04a189",
                            opacity: "1 !important",
                          },
                          "& .MuiSwitch-switchBase.Mui-checked": {
                            color: "#04a189 !important",
                          },
                          "& .MuiSwitch-switchBase": {
                            color: "#ccc !important",
                          },
                        }}
                      />
                    }
                    label="Custom Date"
                    sx={{ margin: 0 }}
                  />
                </div>

                {customDateEnabled && (
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <div className="d-flex align-items-center gap-3">
                      <CustomDateRangePicker
                        from={customFromDate}
                        to={customToDate}
                        onChange={({ from, to }) => {
                          setCustomFromDate(from);
                          setCustomToDate(to);
                          if (from && to) {
                            handleApiCall({
                              project_span: "custom",
                              from_date: from,
                              to_date: to,
                            });
                          }
                        }}
                      />
                      {showClearFilter && (
                        <button
                          type="button"
                          className="addmore_btn"
                          disabled={loading}
                          onClick={handleClearFilter}
                          style={{ height: "35px" }}
                        >
                          Clear Filter
                        </button>
                      )}
                    </div>
                  </LocalizationProvider>
                )}
              </div>

              <div className="d-flex align-items-center gap-2">
                <Tooltip title="Export PDF">
                  <IconButton
                    onClick={handleExportPDF}
                    sx={{
                      backgroundColor: isDarkMode
                        ? "rgba(67, 105, 255, 0.08)"
                        : "#F1F5FF",
                      borderRadius: "50%",
                      width: "39px",
                      height: "39px",
                      color: "rgba(18, 183, 159, 1)",
                      "&:hover": {
                        backgroundColor: "var(--icon-hover-bg)",
                      },
                    }}
                  >
                    <CiExport className="pro-icon-s" />
                  </IconButton>
                </Tooltip>
                <button
                  type="button"
                  className="show-btn text-capitalize border-0"
                  onClick={() => setShowAddScope((open) => !open)}
                >
                  Additional Scope
                </button>
              </div>
            </div>
          </div>
        </Box>
      </form>

      {/* Same "Budget status" card as the employee view. This tab is only
          routed for ADMIN/MANAGER, so the Team drawer gets the Hours vs
          Cost-to-company toggle (cost share is fetched with ?basis=cost). */}
      <BudgetStatusCard
        usedPct={budgetOverview?.budget_status?.budget_used_raw ?? 0}
        usedDisplay={budgetOverview?.budget_status?.budget_used}
        status={budgetOverview?.budget_status?.status ?? "—"}
        isOver={budgetOverview?.budget_status ? budgetOverview.budget_status.status_key !== "healthy" : false}
        gaugeMax={budgetOverview?.budget_status?.gauge?.max ?? 150}
        gaugeMarker={budgetOverview?.budget_status?.gauge?.marker ?? 100}
        projectId={project_id}
        allowCostToggle={true}
        budgetType={budgetTracking.budgetType}
        budgetTracked={budgetTracking.budgetTracked}
        budgetTypeLoading={budgetTracking.loading}
      />

      {/* budget table */}
      <div ref={budgetContainerRef} className="budget-export-pdf-container px-3 py-2">
        {/* PDF Header - Hidden on web UI, revealed only in html2canvas onclone */}
        <div
          id="pdf-header-export-only"
          style={{ display: "none" }}
          className="justify-content-between align-items-start mb-4 pb-3 border-bottom"
        >
          <div className="d-flex flex-column gap-1 text-dark" style={{ fontSize: "14px", color: "#333" }}>
            <div><strong>Project Name : </strong>{displayProjectTitle}</div>
            <div><strong>Project ID : </strong>{project_id || "-"}</div>
            {displayProjectStatus && (
              <div><strong>Project Status : </strong>{displayProjectStatus}</div>
            )}
          </div>
          <div>
            <img src={ttLogo} alt="Techno Tackle Logo" style={{ height: "55px", objectFit: "contain" }} />
          </div>
        </div>

        <div className="budget-pdf-title-container d-flex gap-2 align-items-center mb-2">
          <button
            className="budget_dropdown_btn my-4"
            onClick={() => setBudgetOpen((open) => !open)}
          >
            {budgetOpen ? <ExpandMoreIcon /> : <ExpandLessIcon />}
          </button>
          <Typography
            className="budget-pdf-section-title"
            sx={{ textTransform: "capitalize", fontWeight: "bold", mb: "6px" }}
          >
            Resource Expenses
          </Typography>
        </div>

        <Collapse timeout={700} in={budgetOpen}>
          {loading ? (
            <Loader />
          ) : (
            <BudgetTable
              filteredData={filteredData}
              initialGroupedData={initialGroupedData}
              projectStartDate={
                projectDetails?.start_date ||
                projectInfo?.start_date ||
                projectDetailsData?.start_date
              }
              isInvalidDateRange={Boolean(
                customDateEnabled &&
                  customFromDate &&
                  customToDate &&
                  dayjs(customToDate).isBefore(dayjs(customFromDate), "day")
              )}
              isDateFilterActive={Boolean(
                (customDateEnabled && (customFromDate || customToDate)) ||
                (watch("project_span") !== "all" && isDateApplied)
              )}
            />
          )}
        </Collapse>
        {/* fixeed expanse table */}
        <div className="budget-pdf-title-container d-flex gap-2 align-items-center mb-2">
          <button
            className="budget_dropdown_btn my-4 "
            onClick={() => setOpenFixedExpenseTable((val) => !val)}
          >
            {openFixedExpenseTable ? <ExpandMoreIcon /> : <ExpandLessIcon />}{" "}
          </button>
          <Typography
            className="budget-pdf-section-title"
            sx={{ textTransform: "capitalize", fontWeight: "bold", mb: "6px" }}
          >
            fixed expenses
          </Typography>
        </div>
        <Collapse timeout={700} in={openFixedExpenseTable}>
          <FixedExpenses />
        </Collapse>
        {/* payment method table */}
        <div className="budget-pdf-title-container d-flex gap-2 align-items-center mb-2">
          <button
            className="budget_dropdown_btn my-4"
            onClick={() => setOpenPaymentReceivedTable((open) => !open)}
          >
            {openPaymentReceivedTable ? <ExpandMoreIcon /> : <ExpandLessIcon />}
          </button>
          <Typography
            className="budget-pdf-section-title"
            sx={{ textTransform: "capitalize", fontWeight: "bold", mb: "6px" }}
          >
            payments received
          </Typography>
        </div>
        <Collapse timeout={700} in={openPaymentReceivedTable}>
          <PaymentsReceived />
        </Collapse>
        {/* additional scope table */}
        <div className="budget-pdf-title-container d-flex gap-2 align-items-center mb-2">
          <button
            className="budget_dropdown_btn my-4"
            onClick={() => setOpenAdditionalScopeTable((open) => !open)}
          >
            {openAdditionalScopeTable ? <ExpandMoreIcon /> : <ExpandLessIcon />}
          </button>
          <Typography
            className="budget-pdf-section-title"
            sx={{ textTransform: "capitalize", fontWeight: "bold", mb: "6px" }}
          >
            Additional Scope
          </Typography>
        </div>
        <Collapse timeout={700} in={openAdditionalScopeTable}>
        <AdditionalScopeTable
            data={sortedAdditionalScopes}
            isLoading={additionalScopesLoading}
            onDelete={async (scope_id) => {
              try {
                await deleteAdditionalScope(scope_id).unwrap();
                toast.success("Additional scope deleted successfully");
              } 
              catch (err) {
                const errorMsg = err?.data?.message || err?.message || "Delete failed";
                toast.error(errorMsg);
                throw err;
              }
            }}
            onEdit={(item) => {
              setEditingScopeItem(item);
              setShowAddScope(true);
            }}
          />
        </Collapse>
        {/* summary table */}
        <div className="budget-pdf-title-container d-flex gap-2 align-items-center mb-2">
          <button
            className="budget_dropdown_btn my-4"
            onClick={() => setOpenSummaryTable((open) => !open)}
          >
            {openSummaryTable ? <ExpandMoreIcon /> : <ExpandLessIcon />}
          </button>
          <Typography
            className="budget-pdf-section-title"
            sx={{ textTransform: "capitalize", fontWeight: "bold", mb: "6px" }}
          >
            Summary
          </Typography>
        </div>
        <Collapse timeout={700} in={openSummaryTable}>
          <SummaryTable additionalScopes={sortedAdditionalScopes} refreshKey={budgetRefreshKey} />
        </Collapse>
      </div>
    </div>
  );
};

export default BudgetTab;
